(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 9669:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(1609);

/***/ }),

/***/ 5448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);
var settle = __webpack_require__(6026);
var cookies = __webpack_require__(4372);
var buildURL = __webpack_require__(5327);
var buildFullPath = __webpack_require__(4097);
var parseHeaders = __webpack_require__(4109);
var isURLSameOrigin = __webpack_require__(7985);
var transitionalDefaults = __webpack_require__(7874);
var AxiosError = __webpack_require__(723);
var CanceledError = __webpack_require__(644);
var parseProtocol = __webpack_require__(205);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData) && utils.isStandardBrowserEnv()) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || transitionalDefaults;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || (cancel && cancel.type) ? new CanceledError() : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    var protocol = parseProtocol(fullPath);

    if (protocol && [ 'http', 'https', 'file' ].indexOf(protocol) === -1) {
      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ 1609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);
var bind = __webpack_require__(1849);
var Axios = __webpack_require__(321);
var mergeConfig = __webpack_require__(7185);
var defaults = __webpack_require__(5546);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.CanceledError = __webpack_require__(644);
axios.CancelToken = __webpack_require__(4972);
axios.isCancel = __webpack_require__(6502);
axios.VERSION = (__webpack_require__(7288).version);
axios.toFormData = __webpack_require__(7675);

// Expose AxiosError class
axios.AxiosError = __webpack_require__(723);

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(8713);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(6268);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;


/***/ }),

/***/ 4972:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var CanceledError = __webpack_require__(644);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new CanceledError(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ 644:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(723);
var utils = __webpack_require__(4867);

/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function CanceledError(message) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});

module.exports = CanceledError;


/***/ }),

/***/ 6502:
/***/ (function(module) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ 321:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);
var buildURL = __webpack_require__(5327);
var InterceptorManager = __webpack_require__(782);
var dispatchRequest = __webpack_require__(3572);
var mergeConfig = __webpack_require__(7185);
var buildFullPath = __webpack_require__(4097);
var validator = __webpack_require__(4875);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(configOrUrl, config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof configOrUrl === 'string') {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  var fullPath = buildFullPath(config.baseURL, config.url);
  return buildURL(fullPath, config.params, config.paramsSerializer);
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method: method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url: url,
        data: data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

module.exports = Axios;


/***/ }),

/***/ 723:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);
  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

var prototype = AxiosError.prototype;
var descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED'
// eslint-disable-next-line func-names
].forEach(function(code) {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = function(error, code, config, request, response, customProps) {
  var axiosError = Object.create(prototype);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

module.exports = AxiosError;


/***/ }),

/***/ 782:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ 4097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(1793);
var combineURLs = __webpack_require__(7303);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ 3572:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);
var transformData = __webpack_require__(8527);
var isCancel = __webpack_require__(6502);
var defaults = __webpack_require__(5546);
var CanceledError = __webpack_require__(644);

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ 7185:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'beforeRedirect': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};


/***/ }),

/***/ 6026:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(723);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError(
      'Request failed with status code ' + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ 8527:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);
var defaults = __webpack_require__(5546);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),

/***/ 5546:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(3454);


var utils = __webpack_require__(4867);
var normalizeHeaderName = __webpack_require__(6016);
var AxiosError = __webpack_require__(723);
var transitionalDefaults = __webpack_require__(7874);
var toFormData = __webpack_require__(7675);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(5448);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(5448);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: transitionalDefaults,

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }

    var isObjectPayload = utils.isObject(data);
    var contentType = headers && headers['Content-Type'];

    var isFileList;

    if ((isFileList = utils.isFileList(data)) || (isObjectPayload && contentType === 'multipart/form-data')) {
      var _FormData = this.env && this.env.FormData;
      return toFormData(isFileList ? {'files[]': data} : data, _FormData && new _FormData());
    } else if (isObjectPayload || contentType === 'application/json') {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: __webpack_require__(1623)
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;


/***/ }),

/***/ 7874:
/***/ (function(module) {

"use strict";


module.exports = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};


/***/ }),

/***/ 7288:
/***/ (function(module) {

module.exports = {
  "version": "0.27.2"
};

/***/ }),

/***/ 1849:
/***/ (function(module) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ 5327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ 7303:
/***/ (function(module) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ 4372:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ 1793:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ 6268:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
};


/***/ }),

/***/ 7985:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ 6016:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ 1623:
/***/ (function(module) {

// eslint-disable-next-line strict
module.exports = null;


/***/ }),

/***/ 4109:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ 205:
/***/ (function(module) {

"use strict";


module.exports = function parseProtocol(url) {
  var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
};


/***/ }),

/***/ 8713:
/***/ (function(module) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ 7675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(8764)["lW"];


var utils = __webpack_require__(4867);

/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @returns {Object}
 **/

function toFormData(obj, formData) {
  // eslint-disable-next-line no-param-reassign
  formData = formData || new FormData();

  var stack = [];

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  function build(data, parentKey) {
    if (utils.isPlainObject(data) || utils.isArray(data)) {
      if (stack.indexOf(data) !== -1) {
        throw Error('Circular reference detected in ' + parentKey);
      }

      stack.push(data);

      utils.forEach(data, function each(value, key) {
        if (utils.isUndefined(value)) return;
        var fullKey = parentKey ? parentKey + '.' + key : key;
        var arr;

        if (value && !parentKey && typeof value === 'object') {
          if (utils.endsWith(key, '{}')) {
            // eslint-disable-next-line no-param-reassign
            value = JSON.stringify(value);
          } else if (utils.endsWith(key, '[]') && (arr = utils.toArray(value))) {
            // eslint-disable-next-line func-names
            arr.forEach(function(el) {
              !utils.isUndefined(el) && formData.append(fullKey, convertValue(el));
            });
            return;
          }
        }

        build(value, fullKey);
      });

      stack.pop();
    } else {
      formData.append(parentKey, convertValue(data));
    }
  }

  build(obj);

  return formData;
}

module.exports = toFormData;


/***/ }),

/***/ 4875:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var VERSION = (__webpack_require__(7288).version);
var AxiosError = __webpack_require__(723);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}

module.exports = {
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ 4867:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(1849);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

// eslint-disable-next-line func-names
var kindOf = (function(cache) {
  // eslint-disable-next-line func-names
  return function(thing) {
    var str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
  };
})(Object.create(null));

function kindOfTest(type) {
  type = type.toLowerCase();
  return function isKindOf(thing) {
    return kindOf(thing) === type;
  };
}

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return Array.isArray(val);
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
var isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (kindOf(val) !== 'object') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
var isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
var isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(thing) {
  var pattern = '[object FormData]';
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) ||
    toString.call(thing) === pattern ||
    (isFunction(thing.toString) && thing.toString() === pattern)
  );
}

/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
var isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */

function inherits(constructor, superConstructor, props, descriptors) {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function} [filter]
 * @returns {Object}
 */

function toFlatObject(sourceObj, destObj, filter) {
  var props;
  var i;
  var prop;
  var merged = {};

  destObj = destObj || {};

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if (!merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = Object.getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */
function endsWith(str, searchString, position) {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  var lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object
 * @param {*} [thing]
 * @returns {Array}
 */
function toArray(thing) {
  if (!thing) return null;
  var i = thing.length;
  if (isUndefined(i)) return null;
  var arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

// eslint-disable-next-line func-names
var isTypedArray = (function(TypedArray) {
  // eslint-disable-next-line func-names
  return function(thing) {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && Object.getPrototypeOf(Uint8Array));

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM,
  inherits: inherits,
  toFlatObject: toFlatObject,
  kindOf: kindOf,
  kindOfTest: kindOfTest,
  endsWith: endsWith,
  toArray: toArray,
  isTypedArray: isTypedArray,
  isFileList: isFileList
};


/***/ }),

/***/ 9742:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 8764:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(9742)
var ieee754 = __webpack_require__(645)
var customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.lW = Buffer
__webpack_unused_export__ = SlowBuffer
exports.h2 = 50

var K_MAX_LENGTH = 0x7fffffff
__webpack_unused_export__ = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    var proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    var copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        Buffer.from(buf).copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.h2
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (var i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = (function () {
  var alphabet = '0123456789abcdef'
  var table = new Array(256)
  for (var i = 0; i < 16; ++i) {
    var i16 = i * 16
    for (var j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()


/***/ }),

/***/ 645:
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 3454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) == null ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) == null ? void 0 : ref1.env) === "object" ? __webpack_require__.g.process : __webpack_require__(7663);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 1118:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(8100);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "dv": function() { return /* binding */ useAppProvider; },
/* harmony export */   "mr": function() { return /* binding */ useAppState; },
/* harmony export */   "wI": function() { return /* binding */ AppProvider; }
/* harmony export */ });
/* unused harmony export useAppDispatch */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3725);




var AppStateContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)();
var AppDispatchContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)();
var initialState = {
    history: [],
    favorites: [],
    isLoaded: false
};
var AppReducer = function(state, action) {
    switch(action.type){
        case "SET_APP":
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, initialState, action.payload);
        default:
            {
                return state;
            }
    }
};
var AppProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useReducer)(AppReducer, (0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .cloneObject */ .kI)(initialState)), state = ref[0], dispatch = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!localStorage.getItem("history")) localStorage.setItem("history", JSON.stringify([]));
        if (!localStorage.getItem("favorites")) localStorage.setItem("favorites", JSON.stringify([]));
        dispatch({
            type: "SET_APP",
            payload: {
                history: JSON.parse(localStorage.getItem("history")),
                favorites: JSON.parse(localStorage.getItem("favorites")),
                isLoaded: true
            }
        });
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AppStateContext.Provider, {
        value: state,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AppDispatchContext.Provider, {
            value: dispatch,
            children: children
        })
    });
};
var useAppState = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(AppStateContext);
    if (context === undefined) {
        throw new Error("useAppState must be used within a AppProvider");
    }
    return context;
};
var useAppDispatch = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(AppDispatchContext);
    if (context === undefined) {
        throw new Error("useAppDispatch must be used within a AppProvider");
    }
    return context;
};
var useAppProvider = function() {
    return [
        useAppState(),
        useAppDispatch()
    ];
};


/***/ }),

/***/ 1000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DX": function() { return /* binding */ BuildingsProvider; },
/* harmony export */   "YK": function() { return /* binding */ useBuildingsDispatch; },
/* harmony export */   "iM": function() { return /* binding */ useBuildingsProvider; }
/* harmony export */ });
/* unused harmony export useBuildingsState */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3725);






var BuildingsStateContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)();
var BuildingsDispatchContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)();
var initialState = {
    filter: {
        rooms: [],
        studio: 0,
        priceFrom: "",
        priceTo: "",
        squareFrom: "",
        squareTo: "",
        squareLivingFrom: "",
        squareLivingTo: "",
        squareKitchenFrom: "",
        squareKitchenTo: "",
        floorFrom: "",
        floorTo: "",
        floorsFrom: "",
        floorsTo: "",
        ceiling: "",
        deadlineYear: "",
        deadlineQuartal: "",
        renovation: [],
        buildingType: [],
        balcony: [],
        bathroom: []
    },
    sorting: {
        sort: "price.value",
        sortDirection: "asc"
    },
    pagination: {
        page: 1,
        length: 5
    },
    state: {
        isFiltersMobileVisible: false
    }
};
var BuildingsReducer = function(state, action) {
    switch(action.type){
        case "SET_FILTER":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state), {
                filter: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState.filter, action.payload)
            });
        case "SET_SORTING":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state), {
                sorting: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState.sorting, action.payload)
            });
        case "SET_PAGINATION":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state), {
                pagination: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState.pagination, action.payload)
            });
        case "SET_STATE":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state), {
                state: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState.state, action.payload)
            });
        default:
            {
                return state;
            }
    }
};
var BuildingsProvider = function(param) {
    var children = param.children;
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)(), pathname = ref.pathname, query = ref.query;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useReducer)(BuildingsReducer, (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .cloneObject */ .kI)(initialState), function(state) {
        if (!pathname.startsWith("/[region]/buildings")) return state;
        /** ROOMS */ if (query.studio || query.rooms) {
            if (query.rooms) state.filter.rooms = JSON.parse(query.rooms);
            if (query.studio) state.filter.studio = 1;
        }
        /** PRICE */ if (query.priceFrom) state.filter.priceFrom = query.priceFrom;
        if (query.priceTo) state.filter.priceTo = query.priceTo;
        /** SQUARE */ if (query.squareFrom) state.filter.squareFrom = query.squareFrom;
        if (query.squareTo) state.filter.squareTo = query.squareTo;
        /** LIVING SQUARE */ if (query.squareLivingFrom) state.filter.squareLivingFrom = query.squareLivingFrom;
        if (query.squareLivingTo) state.filter.squareLivingTo = query.squareLivingTo;
        /** KITCHEN SQUARE */ if (query.squareKitchenFrom) state.filter.squareKitchenFrom = query.squareKitchenFrom;
        if (query.squareKitchenTo) state.filter.squareKitchenTo = query.squareKitchenTo;
        /** FLOOR */ if (query.floorFrom) state.filter.floorFrom = query.floorFrom;
        if (query.floorTo) state.filter.floorTo = query.floorTo;
        /** FLOORS */ if (query.floorsFrom) state.filter.floorsFrom = query.floorsFrom;
        if (query.floorsTo) state.filter.floorsTo = query.floorsTo;
        /** CEILING */ if (query.ceiling) state.filter.ceiling = query.ceiling;
        /** RENOVATION */ if (query.renovation) state.filter.renovation = JSON.parse(query.renovation);
        /** BATHROOM */ if (query.bathroom) state.filter.bathroom = JSON.parse(query.bathroom);
        /** BALCONY */ if (query.balcony) state.filter.balcony = JSON.parse(query.balcony);
        /** BUILDING TYPE */ if (query.buildingType) state.filter.buildingType = JSON.parse(query.buildingType);
        /** DEADLINE YEAR */ if (query.deadlineYear) state.filter.deadlineYear = query.deadlineYear;
        /** DEADLINE QUARTAL */ if (query.deadlineQuartal) state.filter.deadlineQuartal = query.deadlineQuartal;
        /** PAGINATION */ if (query.page) state.pagination.page = query.page;
        /** SORTING */ if (query.sort) state.sorting.sort = query.sort;
        if (query.sortDirection) state.sorting.sortDirection = query.sortDirection;
        return state;
    }), state = ref1[0], dispatch = ref1[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BuildingsStateContext.Provider, {
        value: state,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BuildingsDispatchContext.Provider, {
            value: dispatch,
            children: children
        })
    });
};
var useBuildingsState = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(BuildingsStateContext);
    if (context === undefined) {
        throw new Error("useBuildingsState must be used within a BuildingsProvider");
    }
    return context;
};
var useBuildingsDispatch = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(BuildingsDispatchContext);
    if (context === undefined) {
        throw new Error("useBuildingsDispatch must be used within a BuildingsProvider");
    }
    return context;
};
var useBuildingsProvider = function() {
    return [
        useBuildingsState(),
        useBuildingsDispatch()
    ];
};


/***/ }),

/***/ 637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KJ": function() { return /* binding */ useLocationState; },
/* harmony export */   "b8": function() { return /* binding */ useLocationProvider; },
/* harmony export */   "vR": function() { return /* binding */ LocationProvider; }
/* harmony export */ });
/* unused harmony export useLocationDispatch */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _data_location_json__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3479);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3725);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);








var LocationStateContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)();
var LocationDispatchContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)();
var initialState = {
    code: "",
    region: "",
    name: "...",
    case: "...",
    coordinates: [
        47.222078,
        39.720358
    ],
    phone: "...",
    phoneURI: "...",
    zoom: 13,
    isDefault: true,
    isLoaded: false,
    seo: {
        title: "",
        description: "",
        url: "",
        sitename: "",
        footer: ""
    }
};
var LocationReducer = function(state, action) {
    switch(action.type){
        case "SET_LOCATION":
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, initialState, action.payload);
        default:
            {
                return state;
            }
    }
};
var LocationProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useReducer)(LocationReducer, (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .cloneObject */ .kI)(initialState)), state = ref[0], dispatch = ref[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var defaultRegion = "";
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (router && router.query && router.query.region && router.query.region.length > 3) defaultRegion = _data_location_json__WEBPACK_IMPORTED_MODULE_2__.filter(function(v) {
            return v.code === router.query.region;
        });
        axios__WEBPACK_IMPORTED_MODULE_4___default().get("https://api.sypexgeo.net/2Ct1F/json/").then(function(response) {
            var data = response.data;
            console.log(data);
            if (data && data.region && data.region.name_ru && data.ip) {
                try {
                    axios__WEBPACK_IMPORTED_MODULE_4___default().get("https://baza.estate/api/v2" + "/stat/region?ip=" + data.ip + "&region=" + data.region.name_ru);
                } catch (error) {
                //console.log(error);
                }
            }
        }).catch(function(error) {
        //console.log(error);
        });
        if (defaultRegion.length === 0) defaultRegion = _data_location_json__WEBPACK_IMPORTED_MODULE_2__.filter(function(v) {
            return v.code === localStorage.getItem("location");
        });
        if (defaultRegion.length === 0) defaultRegion = _data_location_json__WEBPACK_IMPORTED_MODULE_2__.filter(function(v) {
            return v.isDefault === true;
        });
        dispatch({
            type: "SET_LOCATION",
            payload: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, _data_location_json__WEBPACK_IMPORTED_MODULE_2__.filter(function(v) {
                return v.code === defaultRegion[0].code;
            })[0]), {
                isLoaded: true
            })
        });
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LocationStateContext.Provider, {
        value: state,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LocationDispatchContext.Provider, {
            value: dispatch,
            children: children
        })
    });
};
var useLocationState = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(LocationStateContext);
    if (context === undefined) {
        throw new Error("useLocationState must be used within a LocationProvider");
    }
    return context;
};
var useLocationDispatch = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(LocationDispatchContext);
    if (context === undefined) {
        throw new Error("useLocationDispatch must be used within a LocationProvider");
    }
    return context;
};
var useLocationProvider = function() {
    return [
        useLocationState(),
        useLocationDispatch()
    ];
};


/***/ }),

/***/ 7117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Di": function() { return /* binding */ useMortgageDispatch; },
/* harmony export */   "hF": function() { return /* binding */ useMortgageState; },
/* harmony export */   "kJ": function() { return /* binding */ MortgageProvider; }
/* harmony export */ });
/* unused harmony export useMortgageProvider */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3725);




var MortgageStateContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)();
var MortgageDispatchContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)();
var initialState = {
    objectPrice: 1000000,
    initialFee: 300000,
    mortgageDuration: 5
};
var MortgageReducer = function(state, action) {
    switch(action.type){
        case "SET_MORTGAGE":
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state, action.payload);
        default:
            {
                return state;
            }
    }
};
var MortgageProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useReducer)(MortgageReducer, (0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .cloneObject */ .kI)(initialState)), state = ref[0], dispatch = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MortgageStateContext.Provider, {
        value: state,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MortgageDispatchContext.Provider, {
            value: dispatch,
            children: children
        })
    });
};
var useMortgageState = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(MortgageStateContext);
    if (context === undefined) {
        throw new Error("useMortgageState must be used within a MortgageProvider");
    }
    return context;
};
var useMortgageDispatch = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(MortgageDispatchContext);
    if (context === undefined) {
        throw new Error("useMortgageDispatch must be used within a MortgageProvider");
    }
    return context;
};
var useMortgageProvider = function() {
    return [
        useMortgageState(),
        useMortgageDispatch()
    ];
};


/***/ }),

/***/ 9089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r9": function() { return /* binding */ useNewsProvider; },
/* harmony export */   "s4": function() { return /* binding */ NewsProvider; }
/* harmony export */ });
/* unused harmony exports useNewsState, useNewsDispatch */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3725);






var NewsStateContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)();
var NewsDispatchContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)();
var initialState = {
    filter: {},
    sorting: {
        sort: "updated_at",
        sortDirection: "desc"
    },
    pagination: {
        page: 1,
        length: 6
    }
};
var NewsReducer = function(state, action) {
    switch(action.type){
        case "SET_FILTER":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state), {
                filter: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState.filter, action.payload)
            });
        case "SET_SORTING":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state), {
                sorting: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState.sorting, action.payload)
            });
        case "SET_PAGINATION":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state), {
                pagination: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState.pagination, action.payload)
            });
        case "SET_STATE":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state), {
                state: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState.state, action.payload)
            });
        default:
            {
                return state;
            }
    }
};
var NewsProvider = function(param) {
    var children = param.children;
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)(), pathname = ref.pathname, query = ref.query;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useReducer)(NewsReducer, (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .cloneObject */ .kI)(initialState), function(state) {
        /** PAGINATION */ if (query.page) state.pagination.page = query.page;
        /** SORTING */ if (query.sort) state.sorting.sort = query.sort;
        if (query.sortDirection) state.sorting.sortDirection = query.sortDirection;
        return state;
    }), state = ref1[0], dispatch = ref1[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NewsStateContext.Provider, {
        value: state,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NewsDispatchContext.Provider, {
            value: dispatch,
            children: children
        })
    });
};
var useNewsState = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(NewsStateContext);
    if (context === undefined) {
        throw new Error("useNewsState must be used within a NewsProvider");
    }
    return context;
};
var useNewsDispatch = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(NewsDispatchContext);
    if (context === undefined) {
        throw new Error("useNewsDispatch must be used within a NewsProvider");
    }
    return context;
};
var useNewsProvider = function() {
    return [
        useNewsState(),
        useNewsDispatch()
    ];
};


/***/ }),

/***/ 1563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U_": function() { return /* binding */ useObjectsDispatch; },
/* harmony export */   "kt": function() { return /* binding */ ObjectsProvider; },
/* harmony export */   "v8": function() { return /* binding */ useObjectsProvider; }
/* harmony export */ });
/* unused harmony export useObjectsState */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3725);






var ObjectsStateContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)();
var ObjectsDispatchContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)();
var initialState = {
    filter: {
        type: "продажа",
        category: "квартира",
        rooms: [],
        studio: 0,
        priceFrom: "",
        priceTo: "",
        squareFrom: "",
        squareTo: "",
        squareLivingFrom: "",
        squareLivingTo: "",
        squareKitchenFrom: "",
        squareKitchenTo: "",
        squareAreaFrom: "",
        squareAreaTo: "",
        floorFrom: "",
        floorTo: "",
        floorsFrom: "",
        floorsTo: "",
        ceiling: "",
        stock: [],
        balcony: [],
        renovation: [],
        buildingType: [],
        bathroom: [],
        lotType: [],
        subCategory: [],
        entrance: [],
        commercialType: [],
        commercialBuildingType: [],
        mikroraion: [],
        locality: [],
        noCommission: 0,
        exclusive: 0,
        ads: [],
        images: []
    },
    sorting: {
        sort: "last-update.date",
        sortDirection: ""
    },
    pagination: {
        page: 1,
        length: 8
    },
    map: {
        searchZone: [],
        zoomLevel: 13,
        bbox: []
    },
    reference: {
        locality: []
    },
    state: {
        isFiltersMobileVisible: false,
        isMapCatalogVisible: false
    }
};
var ObjectsReducer = function(state, action) {
    switch(action.type){
        case "SET_FILTER":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state), {
                filter: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState.filter, action.payload)
            });
        case "SET_SORTING":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state), {
                sorting: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState.sorting, action.payload)
            });
        case "SET_PAGINATION":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state), {
                pagination: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState.pagination, action.payload)
            });
        case "SET_MAP":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state), {
                map: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState.map, action.payload)
            });
        case "SET_REFERENCE":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state), {
                reference: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState.reference, action.payload)
            });
        case "SET_STATE":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state), {
                state: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState.state, action.payload)
            });
        default:
            {
                return state;
            }
    }
};
var ObjectsProvider = function(param) {
    var children = param.children;
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)(), pathname = ref.pathname, query = ref.query;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useReducer)(ObjectsReducer, (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .cloneObject */ .kI)(initialState), function(state) {
        if (!pathname.startsWith("/[region]/objects")) return state;
        var type = query.path ? query.path.match(/buy|rent/g) : null;
        var category = query.path ? query.path.match(/flats|rooms|houses|sites|commercial/g) : null;
        var rooms = query.path ? query.path.match(/studio|1k|2k|3k|4k/g) : null;
        /** TYPE */ if (type) {
            switch(type[0]){
                default:
                case "buy":
                    state.filter.type = "продажа";
                    break;
                case "rent":
                    state.filter.type = "аренда";
                    break;
            }
        } else if (query.type) {
            state.filter.type = query.type;
        }
        /** CATEGORY */ if (category) {
            switch(category[0]){
                default:
                case "flats":
                    state.filter.category = "квартира";
                    break;
                case "rooms":
                    state.filter.category = "комната";
                    break;
                case "houses":
                    state.filter.category = "дом";
                    break;
                case "sites":
                    state.filter.category = "участок";
                    break;
                case "commercial":
                    state.filter.category = "коммерция";
                    break;
            }
        } else if (query.category) {
            state.filter.category = query.category;
        }
        /** ROOMS */ if (category && category[0] === "flats" && rooms) {
            switch(rooms[0]){
                case "studio":
                    state.filter.studio = 1;
                    break;
                case "1k":
                    state.filter.rooms = [
                        "1"
                    ];
                    break;
                case "2k":
                    state.filter.rooms = [
                        "2"
                    ];
                    break;
                case "3k":
                    state.filter.rooms = [
                        "3"
                    ];
                    break;
                case "4k":
                    state.filter.rooms = [
                        "4"
                    ];
                    break;
                default:
                    break;
            }
        } else if (query.studio || query.rooms) {
            if (query.rooms) state.filter.rooms = JSON.parse(query.rooms);
            if (query.studio) state.filter.studio = 1;
        }
        /** PRICE */ if (query.priceFrom) state.filter.priceFrom = query.priceFrom;
        if (query.priceTo) state.filter.priceTo = query.priceTo;
        /** SQUARE */ if (query.squareFrom) state.filter.squareFrom = query.squareFrom;
        if (query.squareTo) state.filter.squareTo = query.squareTo;
        /** AREA SQUARE */ if (query.squareAreaFrom) state.filter.squareAreaFrom = query.squareAreaFrom;
        if (query.squareAreaTo) state.filter.squareAreaTo = query.squareAreaTo;
        /** Locality */ if (query.locality) state.filter.locality = JSON.parse(query.locality);
        /** DISTRICT */ if (query.mikroraion) state.filter.mikroraion = JSON.parse(query.mikroraion);
        /** PROMOS */ if (query.noCommission) state.filter.noCommission = 1;
        if (query.exclusive) state.filter.exclusive = 1;
        /** COMMERCIAL TYPE */ if (query.commercialType) state.filter.commercialType = JSON.parse(query.commercialType);
        /** LIVING SQUARE */ if (query.squareLivingFrom) state.filter.squareLivingFrom = query.squareLivingFrom;
        if (query.squareLivingTo) state.filter.squareLivingTo = query.squareLivingTo;
        /** KITCHEN SQUARE */ if (query.squareKitchenFrom) state.filter.squareKitchenFrom = query.squareKitchenFrom;
        if (query.squareKitchenTo) state.filter.squareKitchenTo = query.squareKitchenTo;
        /** FLOOR */ if (query.floorFrom) state.filter.floorFrom = query.floorFrom;
        if (query.floorTo) state.filter.floorTo = query.floorTo;
        /** FLOORS */ if (query.floorsFrom) state.filter.floorsFrom = query.floorsFrom;
        if (query.floorsTo) state.filter.floorsTo = query.floorsTo;
        /** CEILING */ if (query.ceiling) state.filter.ceiling = query.ceiling;
        /** BALCONY */ if (query.balcony) state.filter.balcony = JSON.parse(query.balcony);
        /** RENOVATION */ if (query.renovation) state.filter.renovation = JSON.parse(query.renovation);
        /** BATHROOM */ if (query.bathroom) state.filter.bathroom = JSON.parse(query.bathroom);
        /** BUILDING TYPE */ if (query.buildingType) state.filter.buildingType = JSON.parse(query.buildingType);
        /** STOCK TYPE */ if (query.stock) state.filter.stock = JSON.parse(query.stock);
        /** LOT TYPE */ if (query.lotType) state.filter.lotType = JSON.parse(query.lotType);
        /** SUB CATEGORY */ if (query.subCategory) state.filter.subCategory = JSON.parse(query.subCategory);
        /** ENTRANCE TYPE */ if (query.entrance) state.filter.entrance = JSON.parse(query.entrance);
        /** COMMERCIAL BUILDING TYPE */ if (query.commercialBuildingType) state.filter.commercialBuildingType = JSON.parse(query.commercialBuildingType);
        /** PAGINATION */ if (query.page) state.pagination.page = Number(query.page);
        /** SORTING */ if (query.sort) state.sorting.sort = query.sort;
        if (query.sortDirection) state.sorting.sortDirection = query.sortDirection;
        /** MAP */ if (query.searchZone) state.map.searchZone = JSON.parse(query.searchZone);
        if (query.zoomLevel) state.map.zoomLevel = Number(query.zoomLevel);
        return state;
    }), state = ref1[0], dispatch = ref1[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ObjectsStateContext.Provider, {
        value: state,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ObjectsDispatchContext.Provider, {
            value: dispatch,
            children: children
        })
    });
};
var useObjectsState = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(ObjectsStateContext);
    if (context === undefined) {
        throw new Error("useObjectsState must be used within a ObjectsProvider");
    }
    return context;
};
var useObjectsDispatch = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(ObjectsDispatchContext);
    if (context === undefined) {
        throw new Error("useObjectsDispatch must be used within a ObjectsProvider");
    }
    return context;
};
var useObjectsProvider = function() {
    return [
        useObjectsState(),
        useObjectsDispatch()
    ];
};


/***/ }),

/***/ 3725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ak": function() { return /* binding */ declOfNum; },
/* harmony export */   "Cr": function() { return /* binding */ getTimeInterval; },
/* harmony export */   "J5": function() { return /* binding */ categoryCaseConverter; },
/* harmony export */   "KP": function() { return /* binding */ toMoney; },
/* harmony export */   "SE": function() { return /* binding */ spaceSplitter; },
/* harmony export */   "Vi": function() { return /* binding */ quarterConverter; },
/* harmony export */   "W8": function() { return /* binding */ moneyText; },
/* harmony export */   "_v": function() { return /* binding */ sleep; },
/* harmony export */   "fm": function() { return /* binding */ capitalizeFirstLetter; },
/* harmony export */   "kI": function() { return /* binding */ cloneObject; },
/* harmony export */   "lS": function() { return /* binding */ valueToZero; },
/* harmony export */   "lv": function() { return /* binding */ randomIntFromInterval; },
/* harmony export */   "uO": function() { return /* binding */ getPriceDiff; },
/* harmony export */   "vQ": function() { return /* binding */ copyToClipboard; },
/* harmony export */   "vp": function() { return /* binding */ JSONToQuery; },
/* harmony export */   "x1": function() { return /* binding */ phoneToString; }
/* harmony export */ });
/* unused harmony export toNumber */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var typeof__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6188);
/* harmony import */ var typeof__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(typeof__WEBPACK_IMPORTED_MODULE_1__);


var toMoney = function(data) {
    if (!data) return "0";
    return "".concat(data.toString().replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, " "));
};
var toNumber = function(data) {
    if (!data) return "";
    return Number(data.toString().replace(/[^0-9.]/g, ""));
};
var moneyText = function(money) {
    var moneyNumber = Number(money);
    if (moneyNumber < 1000) return "".concat(Number(moneyNumber.toFixed(1)), " ₽");
    if (moneyNumber < 1000000) return "".concat(Number((moneyNumber / 1000).toFixed(1)), " тыс ₽");
    if (moneyNumber < 1000000000) return "".concat(Number((moneyNumber / 1000000).toFixed(1)), " млн ₽");
    return "".concat(Number((moneyNumber / 1000000000).toFixed(1)), " млрд ₽");
};
var declOfNum = function(n, titles) {
    return titles[// eslint-disable-next-line no-nested-ternary
    n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2];
};
var spaceSplitter = function(num, it) {
    if (!num) return num;
    var reg = new RegExp("(?!^)(?=(?:\\d{".concat(it, "})+(?:\\.|$))"), "gm");
    return num.toString().replace(reg, " ");
};
var randomIntFromInterval = function(min, max) {
    if (!min || !max) return 0;
    return Math.floor(Math.random() * (max - min + 1) + min);
};
var capitalizeFirstLetter = function(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
};
var sleep = function(ms) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, ms);
    });
};
var JSONToQuery = function(j) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    /** First - converting to objects keys.
   *  Second - removing empty array, empty strings and els from ignore list.
   *  Third - converting into string "key=value"
   *  Fourth - removing hidden keys.
   *  Fifth - creating a string.
   */ var jtq = Object.keys(j).filter(function(x) {
        return !i.includes(x) && (j[x] && j[x].length > 0 || Number.isInteger(j[x]) && j[x] > 0);
    }).map(function(k) {
        return "".concat(k, "=").concat(typeof__WEBPACK_IMPORTED_MODULE_1___default()(j[k]) === "array" ? JSON.stringify(j[k]) : j[k]);
    }).filter(function(z) {
        return !r.includes(z);
    }).join("&");
    return "".concat(jtq.length > 0 ? "?" : "").concat(jtq);
};
var phoneToString = function(p) {
    if (!p || p.length !== 11) return p || "";
    return "+".concat(p.slice(0, 1), " ").concat(p.slice(1, 4), " ").concat(p.slice(4, 7), " ").concat(p.slice(7, 9), " ").concat(p.slice(9, 11));
};
var copyToClipboard = function(text) {
    var el = document.createElement("textarea");
    el.value = text;
    el.setAttribute("readonly", "");
    el.style.position = "absolute";
    el.style.left = "-9999px";
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
};
var getPriceDiff = function(t, p) {
    if (!t || !p.value || !p.old) return false;
    if (t === "продажа" && Math.abs(p.value - p.old) >= 10000 || t === "аренда" && Math.abs(p.value - p.old) >= 1000) {
        return {
            value: p.old,
            icon: p.value - p.old > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    color: "#ff8c8c"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "30",
                    height: "30",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                            x1: "12",
                            y1: "19",
                            x2: "12",
                            y2: "5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polyline", {
                            points: "5 12 12 5 19 12"
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    color: "#90e184"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "30",
                    height: "30",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                            x1: "12",
                            y1: "5",
                            x2: "12",
                            y2: "19"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polyline", {
                            points: "19 12 12 19 5 12"
                        })
                    ]
                })
            })
        };
    }
    return false;
};
var getTimeInterval = function(minutes) {
    if (!minutes) return false;
    if (minutes <= 0) minutes = 1;
    if (minutes / 60 < 1) {
        return "".concat(minutes % 60, " ").concat(declOfNum(minutes % 60, [
            "минуту",
            "минуты",
            "минут"
        ]), " назад");
    }
    if (minutes / 60 / 24 < 1) {
        return "".concat(Math.floor(minutes / 60), " ").concat(declOfNum(Math.floor(minutes / 60), [
            "час",
            "часа",
            "часов"
        ]), " назад");
    }
    return "".concat(Math.floor(minutes / 60 / 24), " ").concat(declOfNum(Math.floor(minutes / 60 / 24), [
        "день",
        "дня",
        "дней"
    ]), " назад");
};
var quarterConverter = function(q) {
    switch(q){
        case "1":
            return "I";
        case "2":
            return "II";
        case "3":
            return "III";
        case "4":
            return "IV";
        default:
            return "";
    }
};
var valueToZero = function(v) {
    if (typeof__WEBPACK_IMPORTED_MODULE_1___default()(v) === "array") return [];
    if (typeof__WEBPACK_IMPORTED_MODULE_1___default()(v) === "object") return {};
    if (typeof__WEBPACK_IMPORTED_MODULE_1___default()(v) === "number") return 0;
    if (typeof__WEBPACK_IMPORTED_MODULE_1___default()(v) === "boolean") return false;
    return "";
};
var cloneObject = function(j) {
    return JSON.parse(JSON.stringify(j));
};
var categoryCaseConverter = function(category) {
    var count = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var readyCase = "";
    switch(category){
        case "квартира":
            readyCase = declOfNum(count, [
                "квартира",
                "квартиры",
                "квартир"
            ]);
            break;
        case "комната":
            readyCase = declOfNum(count, [
                "комната",
                "команты",
                "комнат"
            ]);
            break;
        case "дом":
            readyCase = declOfNum(count, [
                "дом",
                "дома",
                "домов"
            ]);
            break;
        case "участок":
            readyCase = declOfNum(count, [
                "участок",
                "участка",
                "участков"
            ]);
            break;
        case "коммерция":
            readyCase = declOfNum(count, [
                "коммерция",
                "коммерции",
                "коммерции"
            ]);
            break;
        default:
            readyCase = declOfNum(count, [
                "вариант",
                "варианта",
                "вариантов"
            ]);
            break;
    }
    return readyCase;
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    toMoney: toMoney,
    toNumber: toNumber,
    moneyText: moneyText,
    declOfNum: declOfNum,
    spaceSplitter: spaceSplitter,
    randomIntFromInterval: randomIntFromInterval,
    capitalizeFirstLetter: capitalizeFirstLetter,
    sleep: sleep,
    JSONToQuery: JSONToQuery,
    phoneToString: phoneToString,
    copyToClipboard: copyToClipboard,
    getPriceDiff: getPriceDiff,
    getTimeInterval: getTimeInterval,
    quarterConverter: quarterConverter,
    valueToZero: valueToZero,
    cloneObject: cloneObject,
    categoryCaseConverter: categoryCaseConverter
});


/***/ }),

/***/ 7080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var useWindowDimensions = function() {
    if (false) {}
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        width: undefined,
        height: undefined
    }), windowDimensions = ref[0], setWindowDimensions = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handleResize = function() {
            setWindowDimensions({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return function() {
            return window.removeEventListener("resize", handleResize);
        };
    }, []);
    return windowDimensions;
};
/* harmony default export */ __webpack_exports__["Z"] = (useWindowDimensions);


/***/ }),

/***/ 8100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./context/app.js
var app = __webpack_require__(9324);
// EXTERNAL MODULE: ./context/location.js
var context_location = __webpack_require__(637);
// EXTERNAL MODULE: ./context/objects.js
var objects = __webpack_require__(1563);
// EXTERNAL MODULE: ./context/buildings.js
var buildings = __webpack_require__(1000);
// EXTERNAL MODULE: ./context/news.js
var news = __webpack_require__(9089);
// EXTERNAL MODULE: ./context/mortgage.js
var mortgage = __webpack_require__(7117);
// EXTERNAL MODULE: ./node_modules/react-yandex-maps/dist/production/react-yandex-maps.esm.js
var react_yandex_maps_esm = __webpack_require__(8112);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./components/Metrics.js



var Metrics = function() {
    return  true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
            strategy: "afterInteractive",
            id: "yandex",
            children: '\n          (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};\n          var z = null;m[i].l=1*new Date();\n          for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}\n          k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})\n          (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");\n\n          ym(90877061, "init", {\n            clickmap: true,\n            trackLinks: true,\n            accurateTrackBounce: true,\n            webvisor: true,\n            trackHash: true\n          });\n        '
        })
    }) : 0;
};
/* harmony default export */ var components_Metrics = (Metrics);

// EXTERNAL MODULE: ./hooks/useWindowDimensions.js
var useWindowDimensions = __webpack_require__(7080);
// EXTERNAL MODULE: ./styles/globals.scss
var globals = __webpack_require__(4831);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./pages/_app.js














var App = function(param) {
    var Component = param.Component, pageProps = param.pageProps;
    var height = (0,useWindowDimensions/* default */.Z)().height;
    (0,react.useEffect)(function() {
        document.documentElement.style.setProperty("--vh", "".concat(window.innerHeight * 0.01, "px"));
    }, [
        height
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(app/* AppProvider */.wI, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(context_location/* LocationProvider */.vR, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(objects/* ObjectsProvider */.kt, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(buildings/* BuildingsProvider */.DX, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mortgage/* MortgageProvider */.kJ, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(news/* NewsProvider */.s4, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_yandex_maps_esm/* YMaps */.Yy, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                                name: "application-name",
                                                content: "База недвижимости"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                                name: "apple-mobile-web-app-capable",
                                                content: "yes"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                                name: "apple-mobile-web-app-status-bar-style",
                                                content: "default"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                                name: "apple-mobile-web-app-title",
                                                content: "База недвижимости"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                                name: "format-detection",
                                                content: "telephone=no"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                                name: "mobile-web-app-capable",
                                                content: "yes"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                                name: "theme-color",
                                                content: "#113376"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                                name: "viewport",
                                                content: "width=device-width, initial-scale=0.9"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                                rel: "manifest",
                                                href: "/manifest.json"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                                rel: "icon",
                                                href: "/icon.png"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                                rel: "apple-touch-icon",
                                                href: "/images/icon.png"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                                                type: "application/ld+json",
                                                dangerouslySetInnerHTML: {
                                                    __html: JSON.stringify({
                                                        "@context": "https://schema.org",
                                                        "@type": "Organization",
                                                        url: "https://".concat("baza.estate"),
                                                        logo: "https://".concat("baza.estate", "/images/icon.png")
                                                    })
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, pageProps)),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Metrics, {})
                                ]
                            })
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ var _app = (App);


/***/ }),

/***/ 4831:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 7663:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={308:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(308);module.exports=r})();

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 1163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(387)


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(699)


/***/ }),

/***/ 8112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bo": function() { return /* binding */ ut; },
/* harmony export */   "D5": function() { return /* binding */ ot; },
/* harmony export */   "Ly": function() { return /* binding */ jt; },
/* harmony export */   "XU": function() { return /* binding */ N; },
/* harmony export */   "Yy": function() { return /* binding */ Z; },
/* harmony export */   "aP": function() { return /* binding */ _t; },
/* harmony export */   "ah": function() { return /* binding */ Pt; },
/* harmony export */   "mg": function() { return /* binding */ Rt; },
/* harmony export */   "ot": function() { return /* binding */ ct; },
/* harmony export */   "zx": function() { return /* binding */ at; }
/* harmony export */ });
/* unused harmony exports Panorama, ListBox, ListBoxItem, RouteButton, RouteEditor, RoutePanel, RulerControl, SearchControl, TrafficControl, TypeSelector, Clusterer, GeoObject, Circle, Polyline, Rectangle */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var e="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof __webpack_require__.g?__webpack_require__.g:"undefined"!=typeof self?self:{};function n(t){return t&&t.__esModule&&Object.prototype.hasOwnProperty.call(t,"default")?t.default:t}function o(t,e){return t(e={exports:{}},e.exports),e.exports}var r="function"==typeof Symbol&&Symbol.for,s=r?Symbol.for("react.element"):60103,i=r?Symbol.for("react.portal"):60106,a=r?Symbol.for("react.fragment"):60107,c=r?Symbol.for("react.strict_mode"):60108,u=r?Symbol.for("react.profiler"):60114,p=r?Symbol.for("react.provider"):60109,f=r?Symbol.for("react.context"):60110,l=r?Symbol.for("react.async_mode"):60111,m=r?Symbol.for("react.concurrent_mode"):60111,d=r?Symbol.for("react.forward_ref"):60112,y=r?Symbol.for("react.suspense"):60113,h=r?Symbol.for("react.suspense_list"):60120,v=r?Symbol.for("react.memo"):60115,b=r?Symbol.for("react.lazy"):60116,j=r?Symbol.for("react.block"):60121,O=r?Symbol.for("react.fundamental"):60117,_=r?Symbol.for("react.responder"):60118,g=r?Symbol.for("react.scope"):60119;function E(t){if("object"==typeof t&&null!==t){var e=t.$$typeof;switch(e){case s:switch(t=t.type){case l:case m:case a:case u:case c:case y:return t;default:switch(t=t&&t.$$typeof){case f:case d:case b:case v:case p:return t;default:return e}}case i:return e}}}function C(t){return E(t)===m}var w={AsyncMode:l,ConcurrentMode:m,ContextConsumer:f,ContextProvider:p,Element:s,ForwardRef:d,Fragment:a,Lazy:b,Memo:v,Portal:i,Profiler:u,StrictMode:c,Suspense:y,isAsyncMode:function(t){return C(t)||E(t)===l},isConcurrentMode:C,isContextConsumer:function(t){return E(t)===f},isContextProvider:function(t){return E(t)===p},isElement:function(t){return"object"==typeof t&&null!==t&&t.$$typeof===s},isForwardRef:function(t){return E(t)===d},isFragment:function(t){return E(t)===a},isLazy:function(t){return E(t)===b},isMemo:function(t){return E(t)===v},isPortal:function(t){return E(t)===i},isProfiler:function(t){return E(t)===u},isStrictMode:function(t){return E(t)===c},isSuspense:function(t){return E(t)===y},isValidElementType:function(t){return"string"==typeof t||"function"==typeof t||t===a||t===m||t===u||t===c||t===y||t===h||"object"==typeof t&&null!==t&&(t.$$typeof===b||t.$$typeof===v||t.$$typeof===p||t.$$typeof===f||t.$$typeof===d||t.$$typeof===O||t.$$typeof===_||t.$$typeof===g||t.$$typeof===j)},typeOf:E};o(function(t,e){}),o(function(t){t.exports=w}),Object,Object,Object,function(){try{if(!Object.assign)return!1;var t=new String("abc");if(t[5]="de","5"===Object.getOwnPropertyNames(t)[0])return!1;for(var e={},n=0;n<10;n++)e["_"+String.fromCharCode(n)]=n;if("0123456789"!==Object.getOwnPropertyNames(e).map(function(t){return e[t]}).join(""))return!1;var o={};return"abcdefghijklmnopqrst".split("").forEach(function(t){o[t]=t}),"abcdefghijklmnopqrst"===Object.keys(Object.assign({},o)).join("")}catch(t){return!1}}()&&Object;var P="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";function R(){}function S(){}Function.call.bind(Object.prototype.hasOwnProperty),S.resetWarningCache=R;var M=o(function(t){t.exports=function(){function t(t,e,n,o,r,s){if(s!==P){var i=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw i.name="Invariant Violation",i}}function e(){return t}t.isRequired=t;var n={array:t,bool:t,func:t,number:t,object:t,string:t,symbol:t,any:t,arrayOf:e,element:t,elementType:t,instanceOf:e,node:t,objectOf:e,oneOf:e,oneOfType:e,shape:e,exact:e,checkPropTypes:S,resetWarningCache:R};return n.PropTypes=n,n}()}),x=n(o(function(t,e){Object.defineProperty(e,"__esModule",{value:!0}),e.default=function(t){return t.displayName||t.name||("string"==typeof t&&t.length>0?t:"Unknown")}})),T=function(t,e){var n={};for(var o in t)-1===e.indexOf(o)&&(n[o]=t[o]);return n},k="__global_unique_id__",$=function(){return e[k]=(e[k]||0)+1},A=function(){},U=o(function(e,n){n.__esModule=!0;var o=s(M),r=s($);function s(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function a(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function c(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}s(A),n.default=function(e,n){var s,u,p="__create-react-context-"+(0,r.default)()+"__",f=function(t){function e(){var n,o,r,s;i(this,e);for(var c=arguments.length,u=Array(c),p=0;p<c;p++)u[p]=arguments[p];return n=o=a(this,t.call.apply(t,[this].concat(u))),o.emitter=(r=o.props.value,s=[],{on:function(t){s.push(t)},off:function(t){s=s.filter(function(e){return e!==t})},get:function(){return r},set:function(t,e){r=t,s.forEach(function(t){return t(r,e)})}}),a(o,n)}return c(e,t),e.prototype.getChildContext=function(){var t;return(t={})[p]=this.emitter,t},e.prototype.componentWillReceiveProps=function(t){if(this.props.value!==t.value){var e=this.props.value,o=t.value,r=void 0;((s=e)===(i=o)?0!==s||1/s==1/i:s!=s&&i!=i)?r=0:(r="function"==typeof n?n(e,o):1073741823,0!=(r|=0)&&this.emitter.set(t.value,r))}var s,i},e.prototype.render=function(){return this.props.children},e}(react__WEBPACK_IMPORTED_MODULE_0__.Component);f.childContextTypes=((s={})[p]=o.default.object.isRequired,s);var l=function(t){function n(){var e,o;i(this,n);for(var r=arguments.length,s=Array(r),c=0;c<r;c++)s[c]=arguments[c];return e=o=a(this,t.call.apply(t,[this].concat(s))),o.state={value:o.getValue()},o.onUpdate=function(t,e){0!=((0|o.observedBits)&e)&&o.setState({value:o.getValue()})},a(o,e)}return c(n,t),n.prototype.componentWillReceiveProps=function(t){var e=t.observedBits;this.observedBits=null==e?1073741823:e},n.prototype.componentDidMount=function(){this.context[p]&&this.context[p].on(this.onUpdate);var t=this.props.observedBits;this.observedBits=null==t?1073741823:t},n.prototype.componentWillUnmount=function(){this.context[p]&&this.context[p].off(this.onUpdate)},n.prototype.getValue=function(){return this.context[p]?this.context[p].get():e},n.prototype.render=function(){return(t=this.props.children,Array.isArray(t)?t[0]:t)(this.state.value);var t},n}(react__WEBPACK_IMPORTED_MODULE_0__.Component);return l.contextTypes=((u={})[p]=o.default.object,u),{Provider:f,Consumer:l}},e.exports=n.default});n(U);var B=n(o(function(e,n){n.__esModule=!0;var o=s(react__WEBPACK_IMPORTED_MODULE_0__),r=s(U);function s(t){return t&&t.__esModule?t:{default:t}}n.default=o.default.createContext||r.default,e.exports=n.default})),D=B(null),L=function(e){var n=x(e);return function(o){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(D.Consumer,null,function(r){if(null===r)throw new Error("Couldn't find Yandex.Maps API in the context. Make sure that <"+n+" /> is inside <YMaps /> provider");return react__WEBPACK_IMPORTED_MODULE_0__.createElement(e,Object.assign({},{ymaps:r},o))})}},F=B(null),W=function(e){return function(n){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(F.Consumer,null,function(o){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(e,Object.assign({},{parent:o},n))})}};function N(e,n,o){void 0===n&&(n=!1),void 0===o&&(o=[]);var r=function(r){function s(){r.call(this),this.state={loading:!0},this._isMounted=!1}return r&&(s.__proto__=r),(s.prototype=Object.create(r&&r.prototype)).constructor=s,s.prototype.componentDidMount=function(){var t=this;this._isMounted=!0,this.props.ymaps.load().then(function(e){return Promise.all(o.concat(t.props.modules).map(e.loadModule)).then(function(){!0===t._isMounted&&t.setState({loading:!1},function(){t.props.onLoad(e)})})}).catch(function(e){!0===t._isMounted&&t.props.onError(e)})},s.prototype.componentWillUnmount=function(){this._isMounted=!1},s.prototype.render=function(){var o=this.props.ymaps,r=!1===n||!1===this.state.loading,s=T(this.props,["onLoad","onError","modules","ymaps"]);return r&&react__WEBPACK_IMPORTED_MODULE_0__.createElement(e,Object.assign({},{ymaps:o.getApi()},s))},s}(react__WEBPACK_IMPORTED_MODULE_0__.Component);return r.defaultProps={onLoad:Function.prototype,onError:Function.prototype,modules:[]},L(r)}var q={lang:"ru_RU",load:"",ns:"",mode:"release"},z={},I=function(t){var e=Date.now().toString(32);this.options=t,this.namespace=t.query.ns||q.ns,this.onload="__yandex-maps-api-onload__$$"+e,this.onerror="__yandex-maps-api-onerror__$$"+e};I.prototype.getApi=function(){return"undefined"!=typeof window&&this.namespace?window[this.namespace]:this.api},I.prototype.setApi=function(t){return this.api=t},I.prototype.getPromise=function(){return this.namespace?z[this.namespace]:this.promise},I.prototype.setPromise=function(t){return this.namespace?z[this.namespace]=this.promise=t:this.promise=t},I.prototype.load=function(){var t=this;if(this.getApi())return Promise.resolve(this.setApi(this.getApi()));if(this.getPromise())return this.setPromise(this.getPromise());var e=Object.assign({onload:this.onload,onerror:this.onerror},q,this.options.query),n=Object.keys(e).map(function(t){return t+"="+e[t]}).join("&"),o=["https://"+(this.options.enterprise?"enterprise.":"")+"api-maps.yandex.ru",this.options.version,"?"+n].join("/"),r=new Promise(function(e,n){window[t.onload]=function(n){delete window[t.onload],n.loadModule=t.loadModule.bind(t),n.ready(function(){return e(t.setApi(n))})},window[t.onerror]=function(e){delete window[t.onerror],n(e)},t.fetchScript(o).catch(window[t.onerror])});return this.setPromise(r)},I.prototype.fetchScript=function(t){var e=this;return new Promise(function(n,o){e.script=document.createElement("script"),e.script.type="text/javascript",e.script.onload=n,e.script.onerror=o,e.script.src=t,e.script.async="async",document.head.appendChild(e.script)})},I.prototype.loadModule=function(t){var e=this;return new Promise(function(n,o){e.getApi().modules.require(t,function(o){!function(t,e,n,o){void 0===o&&(o=!1),e="string"==typeof e?e.split("."):e.slice();for(var r,s=t;e.length>1;)s[r=e.shift()]||(s[r]={}),s=s[r];s[e[0]]=!0===o&&s[e[0]]||n}(e.api,t,o,!0),n(o)},o,e.getApi())})},I._name="__react-yandex-maps__";var Z=function(e){function n(t){e.call(this,t),this.ymaps=new I(t)}return e&&(n.__proto__=e),(n.prototype=Object.create(e&&e.prototype)).constructor=n,n.prototype.componentDidMount=function(){!0===this.props.preload&&this.ymaps.load()},n.prototype.render=function(){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(D.Provider,{value:this.ymaps},this.props.children)},n}(react__WEBPACK_IMPORTED_MODULE_0__.Component);Z.defaultProps={version:"2.1",enterprise:!1,query:{lang:"ru_RU",load:"",ns:""},preload:!1};var G=/^on(?=[A-Z])/;function V(t){return Object.keys(t).reduce(function(e,n){if(G.test(n)){var o=n.replace(G,"").toLowerCase();e._events[o]=t[n]}else e[n]=t[n];return e},{_events:{}})}function Y(t,e,n){"function"==typeof n&&t.events.add(e,n)}function H(t,e,n){"function"==typeof n&&t.events.remove(e,n)}function J(t,e,n){Object.keys(Object.assign({},e,n)).forEach(function(o){e[o]!==n[o]&&(H(t,o,e[o]),Y(t,o,n[o]))})}var K=function(t){return"default"+t.charAt(0).toUpperCase()+t.slice(1)};function Q(t,e){return void 0!==t[e]||void 0===t[K(e)]}function X(t,e,n){return(Q(t,e)?t[e]:t[K(e)])||n}function tt(t,e,n){if(void 0===n&&(n=null),t!==e){if(t&&(t.hasOwnProperty("current")?t.current=null:"function"==typeof t&&t(null)),!e)return;e.hasOwnProperty("current")?e.current=n:"function"==typeof e&&e(n)}}function et(t){var e=t.width,n=t.height,o=t.style,r=t.className;return void 0!==o||void 0!==r?Object.assign({},o&&{style:o},r&&{className:r}):{style:{width:e,height:n}}}var nt=function(e){function n(){var t=this;e.call(this),this.state={instance:null},this._parentElement=null,this._getRef=function(e){t._parentElement=e}}return e&&(n.__proto__=e),(n.prototype=Object.create(e&&e.prototype)).constructor=n,n.prototype.componentDidMount=function(){var t=n.mountObject(this._parentElement,this.props.ymaps.Map,this.props);this.setState({instance:t})},n.prototype.componentDidUpdate=function(t){null!==this.state.instance&&n.updateObject(this.state.instance,t,this.props)},n.prototype.componentWillUnmount=function(){n.unmountObject(this.state.instance,this.props)},n.prototype.render=function(){var e=et(this.props),n=V(this.props),o=T(n,["_events","state","defaultState","options","defaultOptions","instanceRef","ymaps","children","width","height","style","className"]);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(F.Provider,{value:this.state.instance},react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",Object.assign({},{ref:this._getRef},e,o),this.props.children))},n.mountObject=function(t,e,n){var o=V(n),r=o.instanceRef,s=o._events,i=new e(t,X(n,"state"),X(n,"options"));return Object.keys(s).forEach(function(t){return Y(i,t,s[t])}),tt(null,r,i),i},n.updateObject=function(t,e,n){var o=V(n),r=o._events,s=o.instanceRef,i=V(e),a=i._events,c=i.instanceRef;if(Q(n,"state")){var u=X(e,"state",{}),p=X(n,"state",{});u.type!==p.type&&t.setType(p.type),u.behaviors!==p.behaviors&&(u.behaviors&&t.behaviors.disable(u.behaviors),p.behaviors&&t.behaviors.enable(p.behaviors)),p.zoom&&u.zoom!==p.zoom&&t.setZoom(p.zoom),p.center&&u.center!==p.center&&t.setCenter(p.center),p.bounds&&u.bounds!==p.bounds&&t.setBounds(p.bounds)}if(Q(n,"options")){var f=X(e,"options"),l=X(n,"options",{});f!==l&&t.options.set(l)}X(e,"width")===X(n,"width")&&X(e,"height")===X(n,"height")||t.container.fitToViewport(),J(t,a,r),tt(c,s,t)},n.unmountObject=function(t,e){var n=V(e),o=n.instanceRef,r=n._events;null!==t&&(Object.keys(r).forEach(function(e){return H(t,e,r[e])}),t.destroy(),tt(o))},n}(react__WEBPACK_IMPORTED_MODULE_0__.Component);nt.defaultProps={width:320,height:240};var ot=N(nt,!0,["Map"]),rt=function(e){function n(){var t=this;e.call(this),this.state={instance:null},this._parentElement=null,this._getRef=function(e){t._parentElement=e}}return e&&(n.__proto__=e),(n.prototype=Object.create(e&&e.prototype)).constructor=n,n.prototype.componentDidMount=function(){var t=this;this._mounted=!0,this.props.ymaps.panorama.isSupported()&&n.mountObject(this._parentElement,this.props.ymaps.panorama,this.props).then(function(e){return t._mounted&&t.setState({instance:e})})},n.prototype.componentDidUpdate=function(t){null!==this.state.instance&&n.updateObject(this.state.instance,t,this.props)},n.prototype.componentWillUnmount=function(){this._mounted=!1,n.unmountObject(this.state.instance,this.props)},n.prototype.render=function(){var e=et(this.props);return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",Object.assign({},{ref:this._getRef},e))},n.mountObject=function(t,e,n){var o=V(n),r=o.instanceRef,s=o._events,i=X(n,"point"),a=X(n,"locateOptions"),c=X(n,"options");return new Promise(function(n,o){e.locate(i,a).done(function(o){if(o.length>0){var i=new e.Player(t,o[0],c);tt(null,r,i),Object.keys(s).forEach(function(t){return Y(i,t,s[t])}),n(i)}},o)})},n.updateObject=function(t,e,n){var o=V(n),r=o._events,s=o.instanceRef,i=V(e),a=i._events,c=i.instanceRef;if(Q(n,"options")){var u=X(e,"options"),p=X(n,"options");u!==p&&t.options.set(p)}if(Q(n,"point")){var f=X(n,"point"),l=X(e,"point"),m=X(n,"locateOptions");f!==l&&t.moveTo(f,m)}J(t,a,r),tt(c,s,t)},n.unmountObject=function(t,e){var n=V(e),o=n.instanceRef,r=n._events;null!==t&&(Object.keys(r).forEach(function(e){return H(t,e,r[e])}),tt(o))},n}(react__WEBPACK_IMPORTED_MODULE_0__.Component);rt.defaultProps={width:320,height:240};var st=N(rt,!0,["panorama.isSupported","panorama.locate","panorama.createPlayer","panorama.Player"]),it=function(e){function n(){e.call(this),this.state={instance:null}}return e&&(n.__proto__=e),(n.prototype=Object.create(e&&e.prototype)).constructor=n,n.prototype.componentDidMount=function(){var t=n.mountControl(this.props.ymaps.control[this.props.name],this.props);this.setState({instance:t})},n.prototype.componentDidUpdate=function(t){null!==this.state.instance&&n.updateControl(this.state.instance,t,this.props)},n.prototype.componentWillUnmount=function(){n.unmountControl(this.state.instance,this.props)},n.prototype.render=function(){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(F.Provider,{value:this.state.instance},this.props.children)},n.mountControl=function(t,e){var n=V(e),o=n.instanceRef,r=n.parent,s=n.lazy,i=n._events,a=new t({data:X(e,"data"),options:X(e,"options"),state:X(e,"state"),mapTypes:X(e,"mapTypes"),lazy:s});if(Object.keys(i).forEach(function(t){return Y(a,t,i[t])}),r&&r.controls&&"function"==typeof r.controls.add)r.controls.add(a);else{if(!r||!r.add||"function"!=typeof r.add)throw new Error("No parent found to mount "+e.name);r.add(a)}return tt(null,o,a),a},n.updateControl=function(t,e,n){var o=V(n),r=o._events,s=o.instanceRef,i=V(e),a=i._events,c=i.instanceRef;if(Q(n,"options")){var u=X(e,"options"),p=X(n,"options");u!==p&&t.options.set(p)}if(Q(n,"data")){var f=X(e,"data"),l=X(n,"data");f!==l&&t.data.set(l)}if(Q(n,"state")){var m=X(e,"state"),d=X(n,"state");m!==d&&t.state.set(d)}if(Q(n,"mapTypes")){var y=X(e,"mapTypes"),h=X(n,"mapTypes");y!==h&&(t.removeAllMapTypes(),h.forEach(function(e){return t.addMapType(e)}))}J(t,a,r),tt(c,s,t)},n.unmountControl=function(t,e){var n=V(e),o=n.instanceRef,r=n.parent,s=n._events;null!==t&&(Object.keys(s).forEach(function(e){return H(t,e,s[e])}),r.controls&&"function"==typeof r.controls.remove?r.controls.remove(t):r.remove&&"function"==typeof r.remove&&r.remove(t),tt(o))},n}(react__WEBPACK_IMPORTED_MODULE_0__.Component),at=W(N(function(e){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(it,Object.assign({},e,{name:"Button"}))},!0,["control.Button"])),ct=W(N(function(e){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(it,Object.assign({},e,{name:"FullscreenControl"}))},!0,["control.FullscreenControl"])),ut=W(N(function(e){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(it,Object.assign({},e,{name:"GeolocationControl"}))},!0,["control.GeolocationControl"])),pt=W(N(function(e){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(it,Object.assign({},e,{name:"ListBox"}))},!0,["control.ListBox"])),ft=W(N(function(e){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(it,Object.assign({},e,{name:"ListBoxItem"}))},!0,["control.ListBoxItem"])),lt=W(N(function(e){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(it,Object.assign({},e,{name:"RouteButton"}))},!0,["control.RouteButton"])),mt=W(N(function(e){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(it,Object.assign({},e,{name:"RouteEditor"}))},!0,["control.RouteEditor"])),dt=W(N(function(e){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(it,Object.assign({},e,{name:"RoutePanel"}))},!0,["control.RoutePanel"])),yt=W(N(function(e){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(it,Object.assign({},e,{name:"RulerControl"}))},!0,["control.RulerControl"])),ht=W(N(function(e){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(it,Object.assign({},e,{name:"SearchControl"}))},!0,["control.SearchControl"])),vt=W(N(function(e){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(it,Object.assign({},e,{name:"TrafficControl"}))},!0,["control.TrafficControl"])),bt=W(N(function(e){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(it,Object.assign({},e,{name:"TypeSelector"}))},!0,["control.TypeSelector"])),jt=W(N(function(e){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(it,Object.assign({},e,{name:"ZoomControl"}))},!0,["control.ZoomControl"])),Ot=W(N(function(e){function n(){e.call(this),this.state={instance:null}}return e&&(n.__proto__=e),(n.prototype=Object.create(e&&e.prototype)).constructor=n,n.prototype.componentDidMount=function(){var t=n.mountObject(this.props.ymaps.Clusterer,this.props);this.setState({instance:t})},n.prototype.componentDidUpdate=function(t){null!==this.state.instance&&n.updateObject(this.state.instance,t,this.props)},n.prototype.componentWillUnmount=function(){n.unmountObject(this.state.instance,this.props)},n.prototype.render=function(){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(F.Provider,{value:this.state.instance},this.props.children)},n.mountObject=function(t,e){var n=V(e),o=n.instanceRef,r=n.parent,s=n._events,i=new t(X(e,"options"));if(Object.keys(s).forEach(function(t){return Y(i,t,s[t])}),r.geoObjects&&"function"==typeof r.geoObjects.add)r.geoObjects.add(i);else{if(!r.add||"function"!=typeof r.add)throw new Error("No parent found to mount Clusterer");r.add(i)}return tt(null,o,i),i},n.updateObject=function(t,e,n){var o=V(n),r=o._events,s=o.instanceRef,i=V(e),a=i._events,c=i.instanceRef;if(Q(n,"options")){var u=X(e,"options"),p=X(n,"options");u!==p&&t.options.set(p)}J(t,a,r),tt(c,s,t)},n.unmountObject=function(t,e){var n=V(e),o=n.instanceRef,r=n.parent,s=n._events;null!==t&&(Object.keys(s).forEach(function(e){return H(t,e,s[e])}),r.geoObjects&&"function"==typeof r.geoObjects.remove?r.geoObjects.remove(t):r.remove&&"function"==typeof r.remove&&r.remove(t),tt(o))},n}(react__WEBPACK_IMPORTED_MODULE_0__.Component),!0,["Clusterer"])),_t=W(N(function(t){function e(){t.call(this),this.state={instance:null}}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.componentDidMount=function(){var t=e.mountObject(this.props.ymaps.ObjectManager,this.props);this.setState({instance:t})},e.prototype.componentDidUpdate=function(t){null!==this.state.instance&&e.updateObject(this.state.instance,t,this.props)},e.prototype.componentWillUnmount=function(){e.unmountObject(this.state.instance,this.props)},e.prototype.render=function(){return null},e.mountObject=function(t,e){var n=V(e),o=n.instanceRef,r=n.parent,s=n._events,i=X(e,"options",{}),a=X(e,"features",{}),c=X(e,"filter",null),u=X(e,"objects",{}),p=X(e,"clusters",{}),f=new t(i);if(f.add(a||[]),f.setFilter(c),f.objects.options.set(u),f.clusters.options.set(p),Object.keys(s).forEach(function(t){return Y(f,t,s[t])}),r.geoObjects&&"function"==typeof r.geoObjects.add)r.geoObjects.add(f);else{if(!r.add||"function"!=typeof r.add)throw new Error("No parent found to mount ObjectManager");r.add(f)}return tt(null,o,f),f},e.updateObject=function(t,e,n){var o=V(n),r=o._events,s=o.instanceRef,i=V(e),a=i._events,c=i.instanceRef;if(Q(n,"options")){var u=X(e,"options"),p=X(n,"options");u!==p&&t.options.set(p)}if(Q(n,"objects")){var f=X(e,"objects"),l=X(n,"objects");f!==l&&t.objects.options.set(l)}if(Q(n,"clusters")){var m=X(e,"clusters"),d=X(n,"clusters");m!==d&&t.clusters.options.set(d)}if(Q(n,"filter")){var y=X(e,"filter"),h=X(n,"filter");y!==h&&t.setFilter(h)}if(Q(n,"features")){var v=X(e,"features"),b=X(n,"features");v!==b&&(t.remove(v),t.add(b))}J(t,a,r),tt(c,s,t)},e.unmountObject=function(t,e){var n=V(e),o=n.instanceRef,r=n.parent,s=n._events;null!==t&&(Object.keys(s).forEach(function(e){return H(t,e,s[e])}),r.geoObjects&&"function"==typeof r.geoObjects.remove?r.geoObjects.remove(t):r.remove&&"function"==typeof r.remove&&r.remove(t),tt(o))},e}(react__WEBPACK_IMPORTED_MODULE_0__.Component),!0,["ObjectManager"])),gt=function(t){function e(){t.call(this),this.state={instance:null}}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.componentDidMount=function(){var t=this.props,n=t.name,o=t.ymaps,r=t.dangerZone,s=e.mountObject(r&&"function"==typeof r.modifyConstructor?r.modifyConstructor(o[n]):o[n],this.props);this.setState({instance:s})},e.prototype.componentDidUpdate=function(t){null!==this.state.instance&&e.updateObject(this.state.instance,t,this.props)},e.prototype.componentWillUnmount=function(){e.unmountObject(this.state.instance,this.props)},e.prototype.render=function(){return null},e.mountObject=function(t,e){var n=V(e),o=n.instanceRef,r=n.parent,s=n._events,i=new t(X(e,"geometry"),X(e,"properties"),X(e,"options"));if(Object.keys(s).forEach(function(t){return Y(i,t,s[t])}),r&&r.geoObjects&&"function"==typeof r.geoObjects.add)r.geoObjects.add(i);else{if(!r||!r.add||"function"!=typeof r.add)throw new Error("No parent found to mount "+e.name);r.add(i)}return tt(null,o,i),i},e.updateObject=function(t,e,n){var o=V(n),r=o._events,s=o.instanceRef,i=V(e),a=i._events,c=i.instanceRef;if(Q(n,"geometry")){var u=X(e,"geometry",{}),p=X(n,"geometry",{});Array.isArray(p)&&p!==u?Array.isArray(p[0])&&"number"==typeof p[1]?(t.geometry.setCoordinates(p[0]),t.geometry.setRadius(p[1])):t.geometry.setCoordinates(p):"object"==typeof p&&(p.coordinates!==u.coordinates&&t.geometry.setCoordinates(p.coordinates),p.radius!==u.radius&&t.geometry.setRadius(p.radius))}if(Q(n,"properties")){var f=X(e,"properties"),l=X(n,"properties");f!==l&&t.properties.set(l)}if(Q(n,"options")){var m=X(e,"options"),d=X(n,"options");m!==d&&t.options.set(d)}J(t,a,r),tt(c,s,t)},e.unmountObject=function(t,e){var n=V(e),o=n.instanceRef,r=n.parent,s=n._events;null!==t&&(Object.keys(s).forEach(function(e){return H(t,e,s[e])}),r.geoObjects&&"function"==typeof r.geoObjects.remove?r.geoObjects.remove(t):r.remove&&"function"==typeof r.remove&&r.remove(t),tt(o))},e}(react__WEBPACK_IMPORTED_MODULE_0__.Component),Et={modifyConstructor:function(t){function e(e,n,o){t.call(this,{geometry:e,properties:n},o)}return e.prototype=t.prototype,e}},Ct=W(N(function(e){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(gt,Object.assign({},e,{name:"GeoObject",dangerZone:Et}))},!0,["GeoObject"])),wt=W(N(function(e){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(gt,Object.assign({},e,{name:"Circle"}))},!0,["Circle"])),Pt=W(N(function(e){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(gt,Object.assign({},e,{name:"Placemark"}))},!0,["Placemark"])),Rt=W(N(function(e){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(gt,Object.assign({},e,{name:"Polygon"}))},!0,["Polygon"])),St=W(N(function(e){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(gt,Object.assign({},e,{name:"Polyline"}))},!0,["Polyline"])),Mt=W(N(function(e){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(gt,Object.assign({},e,{name:"Rectangle"}))},!0,["Rectangle"]));
//# sourceMappingURL=react-yandex-maps.esm.js.map


/***/ }),

/***/ 6188:
/***/ (function(module) {


var toString = Object.prototype.toString;

module.exports = function(object) {
  var type = typeof object;

  if (type === 'undefined') {
    return 'undefined';
  }
  
  if (object) {
    type = object.constructor.name; 
  } else if (type === 'object') {
    type = toString.call(object).slice(8, -1);
  }

  return type.toLowerCase();
}



/***/ }),

/***/ 4924:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 6042:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4924);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 9396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 3479:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('[{"region":"Алтайский край","name":"Алтайский край","code":"altayskiy_kray","case":"Алтайском крае","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[53.346785,83.77686],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Алтайском крае","description":"Продажа покупка недвижимости в Алтайском крае:Барнаул, Бийск, Новоалтайск, Белокуриха, поселок Черницк. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Алтайском крае: Барнаул, Бийск, Новоалтайск, Белокуриха, поселок Черницк"}},{"region":"Амурская область","name":"Амурская область","code":"amurskaya_oblast","case":"Амурской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[50.290658,127.527173],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Амурской области","description":"Продажа покупка недвижимости в Амурской области:Благовещенск, село Чигири, село Усть-Ивановка, Зея, Тында. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Амурской области: Благовещенск, село Чигири, село Усть-Ивановка, Зея, Тында"}},{"region":"Архангельская область","name":"Архангельская область","code":"arhangelskaya_oblast","case":"Архангельской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[64.539912,40.515762],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Архангельской области","description":"Продажа покупка недвижимости в Архангельской области:Архангельск, Северодвинск, село Холмогоры, деревня Ижма, Новодвинск. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Архангельской области: Архангельск, Северодвинск, село Холмогоры, деревня Ижма, Новодвинск"}},{"region":"Астраханская область","name":"Астраханская область","code":"astrahanskaya_oblast","case":"Астраханской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[46.347616,48.030175],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Астраханской области","description":"Продажа покупка недвижимости в Астраханской области:Астрахань, село Икряное, Камызяк, Ахтубинск, Нариманов. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Астраханской области: Астрахань, село Икряное, Камызяк, Ахтубинск, Нариманов"}},{"region":"Белгородская область","name":"Белгородская область","code":"belgorodskaya_oblast","case":"Белгородской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[50.595415,36.587272],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Белгородской области","description":"Продажа покупка недвижимости в Белгородской области:Белгород, поселок Дубовое, село Таврово, поселок Новосадовый, поселок городского типа Разумное. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Белгородской области: Белгород, поселок Дубовое, село Таврово, поселок Новосадовый, поселок городского типа Разумное"}},{"region":"Брянская область","name":"Брянская область","code":"bryanskaya_oblast","case":"Брянской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[53.243561,34.363428],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Брянской области","description":"Продажа покупка недвижимости в Брянской области:Брянск, Карачев, поселок Синезерки, Фокино, п. Дубровка. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Брянской области: Брянск, Карачев, поселок Синезерки, Фокино, п. Дубровка"}},{"region":"Владимирская область","name":"Владимирская область","code":"vladimirskaya_oblast","case":"Владимирской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[56.129057,40.406635],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Владимирской области","description":"Продажа покупка недвижимости в Владимирской области:Александров, Ковров, Владимирская область, Карабаново, Струнино. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Владимирской области: Александров, Ковров, Владимирская область, Карабаново, Струнино"}},{"region":"Волгоградская область","name":"Волгоградская область","code":"volgogradskaya_oblast","case":"Волгоградской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[48.707068,44.516979],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Волгоградской области","description":"Продажа покупка недвижимости в Волгоградской области:Волгоград, п. Иловля, поселок Царицын, Волжский, Краснослободск. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Волгоградской области: Волгоград, п. Иловля, поселок Царицын, Волжский, Краснослободск"}},{"region":"Вологодская область","name":"Вологодская область","code":"vologodskaya_oblast","case":"Вологодской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[59.220496,39.891523],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Вологодской области","description":"Продажа покупка недвижимости в Вологодской области:Вологда, Череповец, деревня Емельяново, п. Кадуй, Бабаево. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Вологодской области: Вологда, Череповец, деревня Емельяново, п. Кадуй, Бабаево"}},{"region":"Воронежская область","name":"Воронежская область","code":"voronezhskaya_oblast","case":"Воронежской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[51.660779,39.200292],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Воронежской области","description":"Продажа покупка недвижимости в Воронежской области:Воронеж, Лиски, село Архиповка, село Почепское, Калач. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Воронежской области: Воронеж, Лиски, село Архиповка, село Почепское, Калач"}},{"region":"Еврейская автономная область","name":"Еврейская автономная область","code":"evreyskaya_avtonomnaya_oblast","case":"Еврейская автономная область","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[48.789917,132.92475],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Еврейская автономная область","description":"Продажа покупка недвижимости в Еврейская автономная область:Еврейская автономная область, поселок Николаевка, Биробиджан. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Еврейская автономная область: Еврейская автономная область, поселок Николаевка, Биробиджан"}},{"region":"Забайкальский край","name":"Забайкальский край","code":"zabaykalskiy_kray","case":"Забайкальском крае","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[52.033638,113.501052],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Забайкальском крае","description":"Продажа покупка недвижимости в Забайкальском крае:Чита, поселок городского типа Карымское, Краснокаменск, село Кыра, Нерчинск. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Забайкальском крае: Чита, поселок городского типа Карымское, Краснокаменск, село Кыра, Нерчинск"}},{"region":"Ивановская область","name":"Ивановская область","code":"ivanovskaya_oblast","case":"Ивановской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[57.000348,40.973921],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Ивановской области","description":"Продажа покупка недвижимости в Ивановской области:Иваново, Гаврилов Посад, поселок Пестяки, село Буньково, деревня Журихино. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Ивановской области: Иваново, Гаврилов Посад, поселок Пестяки, село Буньково, деревня Журихино"}},{"region":"Иркутская область","name":"Иркутская область","code":"irkutskaya_oblast","case":"Иркутской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[52.28959,104.280608],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Иркутской области","description":"Продажа покупка недвижимости в Иркутской области:Иркутск, п. Маркова, Ангарск, Иркутская область, Братск. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Иркутской области: Иркутск, п. Маркова, Ангарск, Иркутская область, Братск"}},{"region":"Кабардино-Балкарская Республика","name":"Кабардино-Балкарская Республика","code":"kabardino_balkarskaya_respublika","case":"Кабардино-Балкарская Республика","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[43.485259,43.607072],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Кабардино-Балкарская Республика","description":"Продажа покупка недвижимости в Кабардино-Балкарская Республика:село Урвань, село Дыгулыбгей. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Кабардино-Балкарская Республика: село Урвань, село Дыгулыбгей"}},{"region":"Калининградская область","name":"Калининградская область","code":"kaliningradskaya_oblast","case":"Калининградской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[54.710161,20.510138],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Калининградской области","description":"Продажа покупка недвижимости в Калининградской области:Калининград, Светлогорск, поселок Славянское, Гурьевск, поселок Дорожный. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Калининградской области: Калининград, Светлогорск, поселок Славянское, Гурьевск, поселок Дорожный"}},{"region":"Калужская область","name":"Калужская область","code":"kaluzhskaya_oblast","case":"Калужской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[54.513845,36.261215],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Калужской области","description":"Продажа покупка недвижимости в Калужской области:Калуга, Обнинск, деревня Лихун, деревня Шопино, деревня Юрьевка. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Калужской области: Калуга, Обнинск, деревня Лихун, деревня Шопино, деревня Юрьевка"}},{"region":"Камчатский край","name":"Камчатский край","code":"kamchatskiy_kray","case":"Камчатском крае","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[53.024263,158.643504],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Камчатском крае","description":"Продажа покупка недвижимости в Камчатском крае:Петропавловск-Камчатский, Елизово, поселок Раздольный, поселок Пионерский, Вилючинск. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Камчатском крае: Петропавловск-Камчатский, Елизово, поселок Раздольный, поселок Пионерский, Вилючинск"}},{"region":"Карачаево-Черкесская Республика","name":"Карачаево-Черкесская Республика","code":"karachaevo_cherkesskaya_respublika","case":"Карачаево-Черкесской Республике","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[44.228376,42.048277],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Карачаево-Черкесской Республике","description":"Продажа покупка недвижимости в Карачаево-Черкесской Республике:село Архыз, село Учкекен, Карачаевск, поселок Нижний Архыз. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Карачаево-Черкесской Республике: село Архыз, село Учкекен, Карачаевск, поселок Нижний Архыз"}},{"region":"Кемеровская область","name":"Кемеровская область","code":"kemerovskaya_oblast","case":"Кемеровской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[55.3552,86.086848],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Кемеровской области","description":"Продажа покупка недвижимости в Кемеровской области:Новокузнецк, Междуреченск, Прокопьевск, Мыски, Осинники. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Кемеровской области: Новокузнецк, Междуреченск, Прокопьевск, Мыски, Осинники"}},{"region":"Кировская область","name":"Кировская область","code":"kirovskaya_oblast","case":"Кировской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[58.603595,49.668019],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Кировской области","description":"Продажа покупка недвижимости в Кировской области:Киров, Слободской, деревня Шихово, Кировская область, Кирово-Чепецк. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Кировской области: Киров, Слободской, деревня Шихово, Кировская область, Кирово-Чепецк"}},{"region":"Костромская область","name":"Костромская область","code":"kostromskaya_oblast","case":"Костромской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[57.767961,40.926858],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Костромской области","description":"Продажа покупка недвижимости в Костромской области:Кострома, Шарья, Волгореченск, поселок городского типа Поназырево. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Костромской области: Кострома, Шарья, Волгореченск, поселок городского типа Поназырево"}},{"region":"Краснодарский край","name":"Краснодарский край","code":"krasnodarskiy_kray","case":"Краснодарском крае","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[45.03547,38.975313],"zoom":13,"isDefault":true,"showNewBuilding":false,"seo":{"title":"База недвижимости в Краснодарском крае","description":"Продажа покупка недвижимости в Краснодарском крае:Краснодар, Новороссийск, Геленджик, Сочи, станица Елизаветинская. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Краснодарском крае: Краснодар, Новороссийск, Геленджик, Сочи, станица Елизаветинская"}},{"region":"Красноярский край","name":"Красноярский край","code":"krasnoyarskiy_kray","case":"Красноярском крае","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[56.010563,92.852572],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Красноярском крае","description":"Продажа покупка недвижимости в Красноярском крае:Красноярск, поселок городского типа Березовка, поселок Элита, Шарыпово, Березовка. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Красноярском крае: Красноярск, поселок городского типа Березовка, поселок Элита, Шарыпово, Березовка"}},{"region":"Курганская область","name":"Курганская область","code":"kurganskaya_oblast","case":"Курганской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[55.441005,65.341122],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Курганской области","description":"Продажа покупка недвижимости в Курганской области:Курган, Шадринск, Петухово, Курганская область, село Сычево. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Курганской области: Курган, Шадринск, Петухово, Курганская область, село Сычево"}},{"region":"Курская область","name":"Курская область","code":"kurskaya_oblast","case":"Курской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[51.730848,36.193015],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Курской области","description":"Продажа покупка недвижимости в Курской области:поселок Магнитный, Курск, деревня Лисово, поселок Красная Дубрава, Дмитриев. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Курской области: поселок Магнитный, Курск, деревня Лисово, поселок Красная Дубрава, Дмитриев"}},{"region":"Ленинградская область","name":"Ленинградская область","code":"leningradskaya_oblast","case":"Ленинградской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[59.938951,30.315635],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Ленинградской области","description":"Продажа покупка недвижимости в Ленинградской области:Кудрово, Мурино, деревня Разметелево, Ленинградская область, Всеволожск. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Ленинградской области: Кудрово, Мурино, деревня Разметелево, Ленинградская область, Всеволожск"}},{"region":"Липецкая область","name":"Липецкая область","code":"lipetskaya_oblast","case":"Липецкой области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[52.60882,39.59922],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Липецкой области","description":"Продажа покупка недвижимости в Липецкой области:село Измалково, Липецк, хутор Горденин, село Боринское, деревня Студеновка. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Липецкой области: село Измалково, Липецк, хутор Горденин, село Боринское, деревня Студеновка"}},{"region":"Магаданская область","name":"Магаданская область","code":"magadanskaya_oblast","case":"Магаданской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[59.565153,150.80859],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Магаданской области","description":"Продажа покупка недвижимости в Магаданской области:Магадан, поселок городского типа Ола. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Магаданской области: Магадан, поселок городского типа Ола"}},{"region":"Москва","name":"Москва","code":"moskva","case":"Москве","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[55.755864,37.617698],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Москве","description":"Продажа покупка недвижимости в Москве:п. Сосенское, п. Первомайское, Щербинка, п. Московский, п. Филимонковское. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Москве: п. Сосенское, п. Первомайское, Щербинка, п. Московский, п. Филимонковское"}},{"region":"Московская область","name":"Московская область","code":"moskovskaya_oblast","case":"Московской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[55.755863,37.6177],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Московской области","description":"Продажа покупка недвижимости в Московской области:Люберцы, деревня Скурыгино, деревня Ивановка, поселок Нагорное, поселок Развилка. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Московской области: Люберцы, деревня Скурыгино, деревня Ивановка, поселок Нагорное, поселок Развилка"}},{"region":"Мурманская область","name":"Мурманская область","code":"murmanskaya_oblast","case":"Мурманской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[68.970663,33.074914],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Мурманской области","description":"Продажа покупка недвижимости в Мурманской области:Мончегорск, поселок городского типа Верхнетуломский, Североморск, Мурманск, Оленегорск. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Мурманской области: Мончегорск, поселок городского типа Верхнетуломский, Североморск, Мурманск, Оленегорск"}},{"region":"Нижегородская область","name":"Нижегородская область","code":"nizhegorodskaya_oblast","case":"Нижегородской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[56.326799,44.00652],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Нижегородской области","description":"Продажа покупка недвижимости в Нижегородской области:Нижний Новгород, Арзамас, Дзержинск, Кстово, село Елховка. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Нижегородской области: Нижний Новгород, Арзамас, Дзержинск, Кстово, село Елховка"}},{"region":"Новгородская область","name":"Новгородская область","code":"novgorodskaya_oblast","case":"Новгородской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[58.522856,31.269813],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Новгородской области","description":"Продажа покупка недвижимости в Новгородской области:Великий Новгород, деревня Григорово, деревня Заклинье, Ермолинское, деревня Спас-Нередицы. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Новгородской области: Великий Новгород, деревня Григорово, деревня Заклинье, Ермолинское, деревня Спас-Нередицы"}},{"region":"Новосибирская область","name":"Новосибирская область","code":"novosibirskaya_oblast","case":"Новосибирской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[55.030199,82.92043],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Новосибирской области","description":"Продажа покупка недвижимости в Новосибирской области:Новосибирск, Искитим, Карасук, село Сокур, п. Краснообск. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Новосибирской области: Новосибирск, Искитим, Карасук, село Сокур, п. Краснообск"}},{"region":"Омская область","name":"Омская область","code":"omskaya_oblast","case":"Омской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[54.989342,73.368212],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Омской области","description":"Продажа покупка недвижимости в Омской области:Омск, село Надеждино, село Одесское, село Андреевка, село Поповка. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Омской области: Омск, село Надеждино, село Одесское, село Андреевка, село Поповка"}},{"region":"Оренбургская область","name":"Оренбургская область","code":"orenburgskaya_oblast","case":"Оренбургской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[51.768199,55.096955],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Оренбургской области","description":"Продажа покупка недвижимости в Оренбургской области:Оренбург, Орск, Новотроицк, Соль-Илецк, село Озерка. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Оренбургской области: Оренбург, Орск, Новотроицк, Соль-Илецк, село Озерка"}},{"region":"Орловская область","name":"Орловская область","code":"orlovskaya_oblast","case":"Орловской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[52.970758,36.064355],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Орловской области","description":"Продажа покупка недвижимости в Орловской области:Орёл, Мценск, деревня Жилина, деревня Образцово, деревня Еропкино-Большак. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Орловской области: Орёл, Мценск, деревня Жилина, деревня Образцово, деревня Еропкино-Большак"}},{"region":"Пензенская область","name":"Пензенская область","code":"penzenskaya_oblast","case":"Пензенской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[53.195042,45.018318],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Пензенской области","description":"Продажа покупка недвижимости в Пензенской области:Пенза, село Саловка, Пензенская область, Пензенский район, село Васильевка, п. Мокшан. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Пензенской области: Пенза, село Саловка, Пензенская область, Пензенский район, село Васильевка, п. Мокшан"}},{"region":"Пермский край","name":"Пермский край","code":"permskiy_kray","case":"Пермском крае","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[58.010454,56.229441],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Пермском крае","description":"Продажа покупка недвижимости в Пермском крае:Березники, п. Яйва, Пермь, Усолье, село Пыскор. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Пермском крае: Березники, п. Яйва, Пермь, Усолье, село Пыскор"}},{"region":"Приморский край","name":"Приморский край","code":"primorskiy_kray","case":"Приморском крае","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[43.115536,131.885485],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Приморском крае","description":"Продажа покупка недвижимости в Приморском крае:Владивосток, Уссурийск, Дальнереченск, Артем, Арсеньев. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Приморском крае: Владивосток, Уссурийск, Дальнереченск, Артем, Арсеньев"}},{"region":"Псковская область","name":"Псковская область","code":"pskovskaya_oblast","case":"Псковской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[57.819276,28.332458],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Псковской области","description":"Продажа покупка недвижимости в Псковской области:Псков, деревня Хлебаниха, п. Струги Красные, Псковский район, деревня Борисовичи. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Псковской области: Псков, деревня Хлебаниха, п. Струги Красные, Псковский район, деревня Борисовичи"}},{"region":"Республика Адыгея","name":"Республика Адыгея","code":"respublika_adygeya","case":"Республике Адыгея","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[44.60668,40.105853],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Республике Адыгея","description":"Продажа покупка недвижимости в Республике Адыгея:аул Новая Адыгея, поселок городского типа Яблоновский, поселок городского типа Энем, аул Козет, аул Старобжегокай. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Республике Адыгея: аул Новая Адыгея, поселок городского типа Яблоновский, поселок городского типа Энем, аул Козет, аул Старобжегокай"}},{"region":"Республика Алтай","name":"Республика Алтай","code":"respublika_altay","case":"Республике Алтай","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[51.957805,85.960631],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Республике Алтай","description":"Продажа покупка недвижимости в Республике Алтай:Горно-Алтайск, село Горбуново, село Улаган, село Подгорное, село Манжерок. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Республике Алтай: Горно-Алтайск, село Горбуново, село Улаган, село Подгорное, село Манжерок"}},{"region":"Республика Башкортостан","name":"Республика Башкортостан","code":"respublika_bashkortostan","case":"Республике Башкортостан","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[54.735147,55.958727],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Республике Башкортостан","description":"Продажа покупка недвижимости в Республике Башкортостан:Уфа, Янаул, Октябрьский, Нефтекамск, Стерлитамак. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Республике Башкортостан: Уфа, Янаул, Октябрьский, Нефтекамск, Стерлитамак"}},{"region":"Республика Бурятия","name":"Республика Бурятия","code":"respublika_buryatiya","case":"Республике Бурятия","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[51.834811,107.584545],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Республике Бурятия","description":"Продажа покупка недвижимости в Республике Бурятия:Улан-Удэ, село Поселье, село Кабанск, село Нижняя Иволга, Республика Бурятия. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Республике Бурятия: Улан-Удэ, село Поселье, село Кабанск, село Нижняя Иволга, Республика Бурятия"}},{"region":"Республика Дагестан","name":"Республика Дагестан","code":"respublika_dagestan","case":"Республике Дагестан","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[42.983103,47.504748],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Республике Дагестан","description":"Продажа покупка недвижимости в Республике Дагестан:микрорайон М-4, Избербаш, Махачкала, село Карабудахкент, село Цудахар. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Республике Дагестан: микрорайон М-4, Избербаш, Махачкала, село Карабудахкент, село Цудахар"}},{"region":"Республика Калмыкия","name":"Республика Калмыкия","code":"respublika_kalmykiya","case":"Республика Калмыкия","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[46.307743,44.269759],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Республика Калмыкия","description":"Продажа покупка недвижимости в Республика Калмыкия:Элиста. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Республика Калмыкия: Элиста"}},{"region":"Республика Карелия","name":"Республика Карелия","code":"respublika_kareliya","case":"Республике Карелии","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[61.78502,34.346881],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Республике Карелии","description":"Продажа покупка недвижимости в Республике Карелии:поселок Ламберг, Петрозаводск, поселок Куликово, поселок городского типа Надвоицы. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Республике Карелии: поселок Ламберг, Петрозаводск, поселок Куликово, поселок городского типа Надвоицы"}},{"region":"Республика Коми","name":"Республика Коми","code":"respublika_komi","case":"Республике Коми","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[61.668796,50.8365],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Республике Коми","description":"Продажа покупка недвижимости в Республике Коми:село Айкино, Ухта, Инта, Печора, Сыктывкар. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Республике Коми: село Айкино, Ухта, Инта, Печора, Сыктывкар"}},{"region":"Республика Крым","name":"Республика Крым","code":"respublika_krym","case":"Республике Крым","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[44.948237,34.100318],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Республике Крым","description":"Продажа покупка недвижимости в Республике Крым:Симферополь, село Трудовое, село Урожайное, село Мирное, Ялта. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Республике Крым: Симферополь, село Трудовое, село Урожайное, село Мирное, Ялта"}},{"region":"Республика Марий Эл","name":"Республика Марий Эл","code":"respublika_mariy_el","case":"Республике Марий Эл","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[56.6316,47.88618],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Республике Марий Эл","description":"Продажа покупка недвижимости в Республике Марий Эл:Йошкар-Ола, поселок Устье Кундыш, деревня Ким, село Семеновка, хутор Воскресенский. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Республике Марий Эл: Йошкар-Ола, поселок Устье Кундыш, деревня Ким, село Семеновка, хутор Воскресенский"}},{"region":"Республика Мордовия","name":"Республика Мордовия","code":"respublika_mordoviya","case":"Республике Мордовия","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[54.187433,45.183939],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Республике Мордовия","description":"Продажа покупка недвижимости в Республике Мордовия:Саранск, Рузаевка, село Лямбирь, п. Ялга, село Сабур-Мачкасы. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Республике Мордовия: Саранск, Рузаевка, село Лямбирь, п. Ялга, село Сабур-Мачкасы"}},{"region":"Республика Саха (Якутия)","name":"Республика Саха (Якутия)","code":"respublika_saha_yakutiya","case":"Республике Саха (Якутия)","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[62.02722,129.732181],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Республике Саха (Якутия)","description":"Продажа покупка недвижимости в Республике Саха (Якутия):Мирный, Якутск, поселок Айхал, Нюрба, село Сунтар. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Республике Саха (Якутия): Мирный, Якутск, поселок Айхал, Нюрба, село Сунтар"}},{"region":"Республика Северная Осетия-Алания","name":"Республика Северная Осетия-Алания","code":"respublika_severnaya_osetiya_alaniya","case":"Республике Северная Осетия-Алания","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[43.024617,44.681768],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Республике Северная Осетия-Алания","description":"Продажа покупка недвижимости в Республике Северная Осетия-Алания:Владикавказ, Моздок, село Зильги, село Кизляр, село Фарн. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Республике Северная Осетия-Алания: Владикавказ, Моздок, село Зильги, село Кизляр, село Фарн"}},{"region":"Республика Татарстан","name":"Республика Татарстан","code":"respublika_tatarstan","case":"Республике Татарстан","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[55.796129,49.106414],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Республике Татарстан","description":"Продажа покупка недвижимости в Республике Татарстан:Казань, поселок городского типа Васильево, Зеленодольск, поселок городского типа Уруссу, Чистополь. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Республике Татарстан: Казань, поселок городского типа Васильево, Зеленодольск, поселок городского типа Уруссу, Чистополь"}},{"region":"Республика Тыва","name":"Республика Тыва","code":"respublika_tyva","case":"Республика Тыва","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[51.719891,94.437986],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Республика Тыва","description":"Продажа покупка недвижимости в Республика Тыва:село Чаа-Холь, Ак-Довурак. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Республика Тыва: село Чаа-Холь, Ак-Довурак"}},{"region":"Республика Хакасия","name":"Республика Хакасия","code":"respublika_hakasiya","case":"Республике Хакасия","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[53.721152,91.442387],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Республике Хакасия","description":"Продажа покупка недвижимости в Республике Хакасия:Абакан, п. Усть-Абакан, село Аршаново, деревня Летник, деревня Дехановка. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Республике Хакасия: Абакан, п. Усть-Абакан, село Аршаново, деревня Летник, деревня Дехановка"}},{"region":"Ростовская область","name":"Ростовская область","code":"rostovskaya_oblast","case":"Ростовской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[47.222078,39.720349],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Ростовской области","description":"Продажа покупка недвижимости в Ростовской области:Ростов-на-Дону, Шахты, Новочеркасск, Таганрог, Азов. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Ростовской области: Ростов-на-Дону, Шахты, Новочеркасск, Таганрог, Азов"}},{"region":"Рязанская область","name":"Рязанская область","code":"ryazanskaya_oblast","case":"Рязанской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[54.629565,39.741914],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Рязанской области","description":"Продажа покупка недвижимости в Рязанской области:Рязань, п. Шилово, Кораблино, п. Лесной, поселок Денежниково. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Рязанской области: Рязань, п. Шилово, Кораблино, п. Лесной, поселок Денежниково"}},{"region":"Самарская область","name":"Самарская область","code":"samarskaya_oblast","case":"Самарской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[53.195876,50.100199],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Самарской области","description":"Продажа покупка недвижимости в Самарской области:Самара, Тольятти, село Пискалы, поселок Прибрежный, село Выселки. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Самарской области: Самара, Тольятти, село Пискалы, поселок Прибрежный, село Выселки"}},{"region":"Санкт-Петербург","name":"Санкт-Петербург","code":"sankt_peterburg","case":"Санкт-Петербурге","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[59.938955,30.315644],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Санкт-Петербурге","description":"Продажа покупка недвижимости в Санкт-Петербурге:поселок Парголово, поселок Шушары, Красное Село, Колпино, Сестрорецк. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Санкт-Петербурге: поселок Парголово, поселок Шушары, Красное Село, Колпино, Сестрорецк"}},{"region":"Саратовская область","name":"Саратовская область","code":"saratovskaya_oblast","case":"Саратовской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[51.533561,46.034265],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Саратовской области","description":"Продажа покупка недвижимости в Саратовской области:Саратов, Энгельс, п. Приволжский, Красный Кут, п. Лысые Горы. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Саратовской области: Саратов, Энгельс, п. Приволжский, Красный Кут, п. Лысые Горы"}},{"region":"Сахалинская область","name":"Сахалинская область","code":"sahalinskaya_oblast","case":"Сахалинской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[46.95777,142.729587],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Сахалинской области","description":"Продажа покупка недвижимости в Сахалинской области:Южно-Сахалинск, село Соловьевка, Оха, Поронайск, Холмск. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Сахалинской области: Южно-Сахалинск, село Соловьевка, Оха, Поронайск, Холмск"}},{"region":"Свердловская область","name":"Свердловская область","code":"sverdlovskaya_oblast","case":"Свердловской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[61.00318,69.018902],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Свердловской области","description":"Продажа покупка недвижимости в Свердловской области:Нижний Тагил, Екатеринбург, Верхняя Салда, Камышлов, Алапаевск. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Свердловской области: Нижний Тагил, Екатеринбург, Верхняя Салда, Камышлов, Алапаевск"}},{"region":"Севастополь","name":"Севастополь","code":"sevastopol","case":"Севастополе","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[44.556972,33.526402],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Севастополе","description":"Продажа покупка недвижимости в Севастополе:Севастополь, поселок Кача, Инкерман, село Орловка, село Осипенко. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Севастополе: Севастополь, поселок Кача, Инкерман, село Орловка, село Осипенко"}},{"region":"Смоленская область","name":"Смоленская область","code":"smolenskaya_oblast","case":"Смоленской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[54.782634,32.045288],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Смоленской области","description":"Продажа покупка недвижимости в Смоленской области:Смоленск, деревня Гусино, Ярцево, деревня Александровка, деревня Клушино. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Смоленской области: Смоленск, деревня Гусино, Ярцево, деревня Александровка, деревня Клушино"}},{"region":"Ставропольский край","name":"Ставропольский край","code":"stavropolskiy_kray","case":"Ставропольском крае","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[45.043315,41.969111],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Ставропольском крае","description":"Продажа покупка недвижимости в Ставропольском крае:Кисловодск, Михайловск, Георгиевск, село Краснокумское, станица Незлобная. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Ставропольском крае: Кисловодск, Михайловск, Георгиевск, село Краснокумское, станица Незлобная"}},{"region":"Тамбовская область","name":"Тамбовская область","code":"tambovskaya_oblast","case":"Тамбовской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[52.721293,41.452749],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Тамбовской области","description":"Продажа покупка недвижимости в Тамбовской области:Тамбов, Уварово, п. Мордово, Мичуринск, п. Первомайский. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Тамбовской области: Тамбов, Уварово, п. Мордово, Мичуринск, п. Первомайский"}},{"region":"Тверская область","name":"Тверская область","code":"tverskaya_oblast","case":"Тверской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[56.859626,35.911856],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Тверской области","description":"Продажа покупка недвижимости в Тверской области:Вышний Волочек, Бологое, Тверь, Кимры, Зубцов. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Тверской области: Вышний Волочек, Бологое, Тверь, Кимры, Зубцов"}},{"region":"Томская область","name":"Томская область","code":"tomskaya_oblast","case":"Томской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[56.48464,84.947649],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Томской области","description":"Продажа покупка недвижимости в Томской области:Томск, Северск, п. Белый Яр, село Молчаново, Стрежевой. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Томской области: Томск, Северск, п. Белый Яр, село Молчаново, Стрежевой"}},{"region":"Тульская область","name":"Тульская область","code":"tulskaya_oblast","case":"Тульской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[54.193122,37.617348],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Тульской области","description":"Продажа покупка недвижимости в Тульской области:Тула, село Домнино, деревня Скрипово, Новомосковск, деревня Александровка. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Тульской области: Тула, село Домнино, деревня Скрипово, Новомосковск, деревня Александровка"}},{"region":"Тюменская область","name":"Тюменская область","code":"tyumenskaya_oblast","case":"Тюменской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[57.152986,65.541231],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Тюменской области","description":"Продажа покупка недвижимости в Тюменской области:Тюмень, Тобольск, село Абатское, село Юргинское, село Байкалово. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Тюменской области: Тюмень, Тобольск, село Абатское, село Юргинское, село Байкалово"}},{"region":"Удмуртская Республика","name":"Удмуртская Республика","code":"udmurtskaya_respublika","case":"Удмуртской Республике","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[56.852677,53.206896],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Удмуртской Республике","description":"Продажа покупка недвижимости в Удмуртской Республике:Ижевск, Сарапул, поселок Ува, село Пышкет, село Якшур-Бодья. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Удмуртской Республике: Ижевск, Сарапул, поселок Ува, село Пышкет, село Якшур-Бодья"}},{"region":"Ульяновская область","name":"Ульяновская область","code":"ulyanovskaya_oblast","case":"Ульяновской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[54.314194,48.403131],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Ульяновской области","description":"Продажа покупка недвижимости в Ульяновской области:Ульяновск, село Большие Ключищи, Новоульяновск, Барыш, п. Красный Гуляй. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Ульяновской области: Ульяновск, село Большие Ключищи, Новоульяновск, Барыш, п. Красный Гуляй"}},{"region":"Хабаровский край","name":"Хабаровский край","code":"habarovskiy_kray","case":"Хабаровском крае","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[48.480223,135.071917],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Хабаровском крае","description":"Продажа покупка недвижимости в Хабаровском крае:Хабаровск, Комсомольск-на-Амуре, п. Ванино, п. Октябрьский, поселок Маго. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Хабаровском крае: Хабаровск, Комсомольск-на-Амуре, п. Ванино, п. Октябрьский, поселок Маго"}},{"region":"Ханты-Мансийский автономный округ","name":"Ханты-Мансийский автономный округ","code":"hanty_mansiyskiy_avtonomnyy_okrug","case":"Ханты-Мансийском автономном округе","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[61.00318,69.018902],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Ханты-Мансийском автономном округе","description":"Продажа покупка недвижимости в Ханты-Мансийском автономном округе:Когалым, Сургут, Нефтеюганск, Нижневартовск, поселок Сингапай. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Ханты-Мансийском автономном округе: Когалым, Сургут, Нефтеюганск, Нижневартовск, поселок Сингапай"}},{"region":"Челябинская область","name":"Челябинская область","code":"chelyabinskaya_oblast","case":"Челябинской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[55.159897,61.402554],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Челябинской области","description":"Продажа покупка недвижимости в Челябинской области:Миасс, Челябинск, Магнитогорск, Златоуст, Копейск. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Челябинской области: Миасс, Челябинск, Магнитогорск, Златоуст, Копейск"}},{"region":"Чеченская Республика","name":"Чеченская Республика","code":"chechenskaya_respublika","case":"Чеченской Республике","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[43.318368,45.692419],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Чеченской Республике","description":"Продажа покупка недвижимости в Чеченской Республике:Грозный, село Гелдаган, Гудермес, село Бачи-Юрт, село Хамби-Ирзи. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Чеченской Республике: Грозный, село Гелдаган, Гудермес, село Бачи-Юрт, село Хамби-Ирзи"}},{"region":"Чувашская Республика","name":"Чувашская Республика","code":"chuvashskaya_respublika","case":"Чувашской Республике","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[56.13992,47.247731],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Чувашской Республике","description":"Продажа покупка недвижимости в Чувашской Республике:Чебоксары, деревня Малое Шахчурино, село Шемурша, Новочебоксарск, село Красноармейское. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Чувашской Республике: Чебоксары, деревня Малое Шахчурино, село Шемурша, Новочебоксарск, село Красноармейское"}},{"region":"Ямало-Ненецкий автономный округ","name":"Ямало-Ненецкий автономный округ","code":"yamalo_nenetskiy_avtonomnyy_okrug","case":"Ямало-Ненецком автономном округе","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[66.529865,66.614507],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Ямало-Ненецком автономном округе","description":"Продажа покупка недвижимости в Ямало-Ненецком автономном округе:село Яр-Сале, Салехард, Тарко-Сале, Надым, Новый Уренгой. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Ямало-Ненецком автономном округе: село Яр-Сале, Салехард, Тарко-Сале, Надым, Новый Уренгой"}},{"region":"Ярославская область","name":"Ярославская область","code":"yaroslavskaya_oblast","case":"Ярославской области","phone":"8 800 555 35 35","phoneURI":"tel:+78005553535","coordinates":[57.62656,39.893813],"zoom":13,"isDefault":false,"showNewBuilding":false,"seo":{"title":"База недвижимости в Ярославской области","description":"Продажа покупка недвижимости в Ярославской области:Ярославль, Углич, Гаврилов-Ям, Переславль-Залесский, Рыбинск. Объявления, поиск, цены, купить недвижимость, снять квартиру, купить жилье, снять жилье, арендовать офис, купить дом","url":"https://baza.estate","sitename":"baza.estate","footer":"Ярославской области: Ярославль, Углич, Гаврилов-Ям, Переславль-Залесский, Рыбинск"}}]');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(1118), __webpack_exec__(387); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);